// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:12:01.595Z
// Property: Tower 12 (ID: 4835820926140416)
// Collections: 161 amenities, 28 floorplans (live), 24 photos, 44 POIs, 5 reviews, 34 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "4835820926140416",
  "property_external_id": "1021901",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/tower-12/CgKKmQ/",
  "property_apartments_url": "https://www.apartments.com/tower-12-seattle-wa/sx3e5w7",
  "property_google_business_url": "https://www.google.com/maps/place/Tower+12+Apartment+Homes/@47.6118453,-122.3422124,15z/data=!4m2!3m1!1s0x0:0xf55a48883f2a8551?sa=X&ved=2ahUKEwiD7qOIhfTtAhVCuVkKHdzbBdAQ_BIwE3oECCoQBQ",
  "property_linkedin_url": null,
  "property_hubspot_id": "5535327834",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "tower-12",
  "property_name": "Tower 12",
  "property_website_url": "https://www.tower12.com/",
  "property_domain": "https://www.tower12.com/",
  "property_address": "2015 2nd Avenue",
  "property_full_address": "2015 2nd Avenue, Seattle, WA 98121",
  "property_address_1": "2015 2nd Avenue",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": "98121",
  "property_address_zip": "98121",
  "property_address_country": null,
  "property_address_county": "King",
  "property_neighborhood_address": "Pike Place Market",
  "property_address_latitude": "47.6118",
  "property_address_longitude": "-122.3425",
  "property_email": "tower12@weidner.com",
  "property_phone": "(833) 227-3410",
  "property_call_tracking_phone": "206-709-5373",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Tower 12 puts you at the epicenter of vibrant downtown living, offering custom studios, one, and two-bedroom apartments, and penthouses with sophisticated architecture and designer finishes.</p>",
  "property_long_description": "<p>Live in a gorgeous apartment in the center of the Belltown neighborhood with exceptional amenities in a friendly and active atmosphere. Enjoy living within the epitome of the Seattle experience with Pike Place Market, award-winning restaurants, and the Westlake Shopping Center steps from your home.</p><p>Tower 12 offers luxurious studio, one and two-bedroom pet-friendly apartments and penthouses that showcase stunning views of downtown and Puget Sound. Your apartment will have superior amenities, like a gourmet kitchen, quartz countertops, A/C, full-size in-unit laundry, and plank hardwood-style flooring.</p><p>Expand your living space with outstanding community amenities, including a rooftop sky lounge, a state-of-the-art fitness center, a theater, a reservable clubhouse, and more. You’ll enjoy connecting with your neighbors at the weekly resident events held by our industry-leading leasing team and concierge.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-b290-76de-8e56-d47371541f8b.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living room with large windows and a modern kitchen.",
    "public_id": "01a03751-b290-76de-8e56-d47371541f8b",
    "storage_key": "property/4835820926140416/01a03751-b290-76de-8e56-d47371541f8b.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": "https://media.multihub.io/property/4835820926140416/019e4084-09af-7002-b417-e270e2f876fa.m4v",
  "property_featured_video_media": {
    "public_id": "019e4084-09af-7002-b417-e270e2f876fa",
    "storage_key": "property/4835820926140416/019e4084-09af-7002-b417-e270e2f876fa.m4v",
    "thumbnail_key": "property/4835820926140416/019e4084-09af-7002-b417-e270e2f876fa_thumb.webp",
    "size_bytes": 19371216,
    "classification": "Apartment",
    "title": "Luxury Apartment Interior Tour",
    "description": "Explore the elegant interiors of our luxury apartments, featuring modern kitchens, spacious bedrooms, and spa-like bathrooms with stunning city views."
  },
  "property_total_units": "314",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": "99",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.85987261146497",
  "property_admin_fee": null,
  "property_application_fee": "10",
  "property_fees_deposit_info": "Security deposit: $100",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": "Pet Policy\nPets - Max 2 allowed\nComments: No weight restrictions.",
  "property_online_leasing_url": "https://tower12.securecafe.com/onlineleasing/tower-12/floorplans.aspx",
  "property_resident_portal_url": "https://tower12.securecafenet.com/residentservices/tower-12/userlogin",
  "property_apply_now_url": "https://tower12.securecafe.com/onlineleasing/tower-12/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-046c-75bb-9373-a4477c5dd71e.webp",
  "property_primary_logo_media": {
    "alt_text": "Tower 12 Apartments logo",
    "public_id": "019d0199-046c-75bb-9373-a4477c5dd71e",
    "storage_key": "property/4835820926140416/019d0199-046c-75bb-9373-a4477c5dd71e.webp",
    "width": 600,
    "height": 279
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d019a-a75d-755c-bad9-dc98a5c2e41b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d019a-a75d-755c-bad9-dc98a5c2e41b",
    "storage_key": "property/4835820926140416/019d019a-a75d-755c-bad9-dc98a5c2e41b.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019e4081-e6dc-7266-a242-d3f709561871.webp",
  "property_icon_media": {
    "alt_text": "The Townes12 logo",
    "public_id": "019e4081-e6dc-7266-a242-d3f709561871",
    "storage_key": "property/4835820926140416/019e4081-e6dc-7266-a242-d3f709561871.webp",
    "width": 32,
    "height": 32
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019e4081-e6dc-7266-a242-d3f709561871.webp",
  "property_fav_icon_media": {
    "alt_text": "The Townes12 logo",
    "public_id": "019e4081-e6dc-7266-a242-d3f709561871",
    "storage_key": "property/4835820926140416/019e4081-e6dc-7266-a242-d3f709561871.webp",
    "width": 32,
    "height": 32
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019e407f-6f19-7314-a024-d08d57967c23.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e407f-6f19-7314-a024-d08d57967c23",
    "storage_key": "property/4835820926140416/019e407f-6f19-7314-a024-d08d57967c23.webp",
    "width": 600,
    "height": 279
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019e407f-63ce-709e-866d-c29fa7329efe.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e407f-63ce-709e-866d-c29fa7329efe",
    "storage_key": "property/4835820926140416/019e407f-63ce-709e-866d-c29fa7329efe.webp",
    "width": 600,
    "height": 279
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#a37c20",
  "property_font_color": "#ffffff",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": " - 1808",
  "property_sqft_min": "571",
  "property_sqft_max": "1825",
  "property_price_range": "212 - 9080",
  "property_price_min": "2350",
  "property_price_max": "9080",
  "property_available_units": 13,
  "property_facebook_url": "N/A---\n\n\n\nhttps://www.yelp.com/biz/tower12-seattle",
  "property_instagram_url": "https://www.instagram.com/Tower12Apartments/",
  "property_twitter_url": "https://twitter.com/Tower12Apts",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJAfgPqUwVkFQRUYUqP4hIWvU",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Tower 12",
  "property_home_romance_title": "The best of modern living with luxurious layouts and panoramic views in the heart of downtown.",
  "property_home_amenities_blurb": "<p>Expand your living space with outstanding community amenities, including a rooftop sky lounge, a state-of-the-art fitness center, a theater, a reservable clubhouse, and more. You’ll enjoy connecting with your neighbors at the weekly resident events held by our industry-leading leasing team and concierge.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with a point of view.</strong> From streamlined studios to penthouses, Tower 12 offers layouts with polished finishes and practical flow—quartz countertops, gas ranges, full-size washers and dryers, central air, plank flooring, walk-in closets, and deep soaking tubs. Select homes raise the bar with balconies, vaulted ceilings, wine refrigerators, gas fireplaces, and sweeping Seattle views.</p>",
  "property_home_gallery_blurb": "<p>Tower 12 is centrally located between Seattle’s vibrant Belltown and Downtown neighborhoods. You’ll never run out of fun things to do with iconic Seattle venues like Moore Theater, Seattle Center, Climate Pledge Arena, Westlake Shopping Center, and the Seattle waterfront just a quick stroll or monorail ride away. However, if you need to leave downtown, it’s a breeze, with easy access to Highway 99, I-5, and public transit options.</p>",
  "property_home_neighborhood_blurb": "<p>Live in an exquisite, expertly-designed community conveniently located downtown near beloved Seattle hot spots, award-winning restaurants, top-tier shopping, and world-class entertainment. Tower 12 is the perfect place to relax and rejuvenate after exploring Seattle’s limitless sights, sounds, and flavors.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents give Tower 12 high marks for everyday ease and skyline-level perks.</strong> Reviews call out a welcoming concierge team, responsive maintenance, smooth package handling, and well-kept spaces throughout the building. The rooftop, 34th-floor veranda, fitness areas, fireplaces, in-building deli, and standout sunset views all get plenty of love—along with clean apartments, dependable finishes, and a high-rise experience residents are happy to recommend.</p>",
  "property_neighborhood_blurb": "<p>Live in an exquisite, expertly-designed community conveniently located downtown near beloved Seattle hot spots, award-winning restaurants, top-tier shopping, and world-class entertainment. Tower 12 is the perfect place to relax and rejuvenate after exploring Seattle’s limitless sights, sounds, and flavors.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich high-rise living, made effortless.</strong> At Tower 12, your day can move from a concierge-handled package pickup to a Fitness-On-Demand session, a quiet reset in the yoga studio, or an evening in the reservable Sky Lounge with gas grills and open-air deck space. Practical perks—controlled access, on-site management and maintenance, dry cleaning services, bike storage with a wash station, EV charging, and fiber-optic internet—keep the details running smoothly.</p><p>Inside, polished finishes bring the same level of intention: quartz countertops, gas ranges, full-size washers and dryers, central AC, deep soaking tubs, custom closets, USB charging ports, and select extras like balconies, wine refrigerators, vaulted ceilings, and gas fireplaces. Preview the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Apply online and start your next chapter at Tower 12.</strong> Choose from luxury one- and two-bedroom apartments, including penthouses and homes with private decks, then settle into downtown Seattle living with high-end finishes, friendly service, and skyline views designed for everyday recharge.</p>",
  "property_contactus_blurb": "<p>Fill out the form below, drop us a line, or stop by to learn how you can start living in luxury at Tower 12.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Tower 12?</strong> Start here for quick answers about leasing, community features, pet-friendly living, and everyday life in the heart of Seattle. Explore details on <a href=\"/floor-plans\">floor plans</a>, <a href=\"/amenities\">amenities</a>, and policies—or <a href=\"/contact-us\">contact the leasing team</a> anytime for help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the view, flow, and finish that fit your day.</strong> Tower 12’s floor plans span efficient studios, open one-bedroom layouts, one-bedrooms with dens, roomy two-bedrooms, and elevated penthouse residences—so you can compare homes by how you actually live.</p><p>Look for thoughtful details that make each layout feel polished and practical: quartz countertops, gas ranges, kitchen islands or pantries in select homes, full-size washers and dryers, central air and heating, hardwood-style plank flooring, walk-in closets, deep soaking tubs, USB charging ports, and hidden TV outlets. Select homes add balconies, vaulted ceilings, wine refrigerators, custom gas fireplaces, and sweeping Seattle views. Browse current availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which plan feels right in person.</p>",
  "property_gallery_blurb": "<p>You belong here! Picture yourself in Tower 12’s luxury apartments in downtown Seattle, WA. Notice each home’s elevated features, view the desirable amenities, and take in the community’s welcoming atmosphere.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Tower 12 on the map.</strong> See available apartments at 2015 2nd Avenue, then zoom out to discover the downtown dining, shopping, entertainment, transit, and Belltown-to-Downtown energy that surround home. Start with <a href=\"/floor-plans\">available floor plans</a>, then explore the <a href=\"/neighborhood\">neighborhood</a>.</p>",
  "property_pets_blurb": "<p>At Tower 12, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours…</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Tower 12?</strong> Share the downtown Seattle energy, stunning skyline views, luxury finishes, pet-loving perks, and active community events with a friend. Invite them to explore Tower 12 Apartment Homes and see why it’s such a refreshing place to come home to.</p>",
  "property_residentaccess_blurb": "<p><strong>Welcome home to Tower 12.</strong> Use Resident Access to pay rent, submit maintenance requests, and manage your account with ease. From friendly staff to 24-hour on-call maintenance, the Tower 12 team is here to help keep downtown Seattle living smooth, connected, and convenient.</p>",
  "property_reviews_blurb": "<p><strong>See what life at Tower 12 feels like, in residents’ own words.</strong> Reviews consistently point to a welcoming team, smooth day-to-day service, and a building that feels well cared for. Residents praise the concierge crew for keeping deliveries, communications, and events running smoothly, while maintenance is described as quick, efficient, and respectful.</p><p>You’ll also see plenty of love for the spaces above the city: the rooftop, 34th-floor veranda, fitness areas, fireplaces, and “truly stellar sunset views.” From clean, thoughtfully designed apartments to dependable finishes and a convenient in-building deli, Tower 12 earns high marks for comfort, care, and a Seattle high-rise experience that residents are happy to recommend.</p>",
  "property_created_at": "1752256181822",
  "property_scheduletour_blurb": "<p><strong>See Tower 12 up close.</strong> Tour luxury one and two bedroom apartments with quartz kitchens, tall ceilings, large windows, and select private decks with Puget Sound views. Then explore the rooftop Sky Lounge, fireside library, fitness spaces, and more. <a href=\"/contact-us\">Schedule your personal tour</a> today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Tower 12 Apartment Homes.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture downtown Seattle living with stylish one and two bedroom homes, striking skyline views, welcoming community spaces, and a location made for exploring the city.</p>",
  "property_virtualtours_blurb": "<p><strong>Take the tour before you choose the view.</strong> Explore Tower 12 from wherever you are with immersive virtual walkthroughs that help you compare the spaces that matter most. Start with the Lobby and Sky Lounge, then move through available studio, one-bedroom, one-bedroom-plus-den, two-bedroom, two-bedroom-plus-den, and penthouse tours.</p><p>Look closely at the details that shape each home: Sand and Driftwood finish options, open kitchens with quartz surfaces, plank-style flooring, full-size laundry, walk-in storage, den space, and high-rise outlooks in select apartment and penthouse tours. Use each walkthrough to test the flow room by room, then compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Tower 12 in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Tower 12",
  "property_seo_title_home": "Tower 12 |  Apartments in Seattle, WA",
  "property_seo_description_home": "Experience luxury living at Tower 12 in Seattle! Choose from stylish studio to two-bedroom apartments with top-notch amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Unlock your ideal living space at Tower 12 in Seattle, WA. From studios to two-bedroom apartments, browse our diverse floor plans today!",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Tower 12 in Seattle! Enjoy luxury amenities, stunning floor plans, and vibrant community features tailored for you. Welcome home!",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Elevate your life at Tower 12 in Seattle, WA. Enjoy luxurious floor plans and top-notch amenities in a vibrant community. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Tower 12 Apartments",
  "property_seo_description_virtualtours": "Step inside Tower 12 in Seattle, WA! Experience our studio, one, and two-bedroom apartments through a captivating virtual tour of your future home.",
  "property_seo_title_interactivemap": "Interactive Map | Tower 12 Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Tower 12 in Seattle! Explore our interactive map for studios and two-bedroom apartments with luxury amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Uncover the vibrant Seattle life around Tower 12! Dive into local favorites and essential points of interest just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Tower 12",
  "property_seo_description_contact": "Reach out to Tower 12 in Seattle! Our leasing team is ready to answer your questions about our stylish studios and spacious one- and two-bedroom apartments.",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Find answers to all your questions about Tower 12 in Seattle—your stylish haven with top-notch amenities, chic floor plans, and a vibrant community atmosphere.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "Join the vibrant community at Tower 12 in Seattle! Read our residents' reviews and discover the exceptional lifestyle and amenities that await you.",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Elevate your lifestyle at Tower 12 in Seattle! Enjoy luxury amenities, stylish floor plans, and a vibrant community. Lease online and make it home today!",
  "property_seo_title_residentaccess": "Resident Access | Tower 12",
  "property_seo_description_residentaccess": "Welcome to Tower 12 in Seattle! Log in to your resident portal now for seamless rent payments, maintenance requests, and community updates at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Tower 12",
  "property_seo_description_referafriend": "Refer a friend to Tower 12 in Seattle, WA! Great friends make great neighbors—share the joy of elevated living in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Tower 12",
  "property_seo_description_scheduletour": "Experience urban living at Tower 12 in Seattle, WA. Schedule your tour today and envision your future home filled with luxury, community, and stunning views!",
  "property_seo_title_privacy": "Privacy Policy | Tower 12",
  "property_seo_description_privacy": "Your privacy matters! At Tower 12 in Seattle, our policy ensures your information is protected. See how we safeguard your personal data today.",
  "property_seo_title_accessibility": "Website Accessibility | Tower 12",
  "property_seo_description_accessibility": "At Tower 12 in Seattle, we prioritize digital accessibility for all residents. Join us in fostering an inclusive community where everyone thrives!",
  "property_seo_title_sitemap": "Sitemap | Tower 12",
  "property_seo_description_sitemap": "Navigate your way to your new home at Tower 12 in Seattle! Check out our sitemap for a seamless journey through our vibrant community and amenities.",
  "property_seo_title_thankyou": "Thank You | Tower 12",
  "property_seo_description_thankyou": "Thank you for reaching out to Tower 12 in Seattle! Our team will connect with you soon to help you find your ideal apartment in the heart of the city.",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793650706665",
  "amenities": [
    {
      "id": "ec_28c7ce70f6fc23c85064fe11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897968",
      "title": "24 Hour Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df16d95bba372edfb933347e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897969",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50e69500d4fdca6280073641",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897970",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36816b4cc379e9ccc1297044",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897973",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ba5fc449d334a2df0fae955",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897974",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de6f7a8fbba8dbe0aa9ebfd3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897976",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cb78cfe7daa21a3a30830d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897977",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cece6d191f34730a6b17d25d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897981",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f65ed5daffd747ad905b05f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897983",
      "title": "Reserveable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d99d9-9d0d-749c-84dc-639d3dc737e2.webp",
      "amenity_image_media": {
        "alt_text": "Modern apartment lounge with a fireplace, leather sofa, and blue accent chairs.",
        "public_id": "019d99d9-9d0d-749c-84dc-639d3dc737e2",
        "storage_key": "property/4835820926140416/019d99d9-9d0d-749c-84dc-639d3dc737e2.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4634239c65d92bb7f5da433f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897992",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e785d8c1cd110d599313ee5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897993",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5413e71932f13e0fcdb852f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897997",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-c33e-708c-9cc4-453afddeeb6f.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills and weight machines overlooking the ocean",
        "public_id": "01a03c73-c33e-708c-9cc4-453afddeeb6f",
        "storage_key": "property/4835820926140416/01a03c73-c33e-708c-9cc4-453afddeeb6f.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc1107b93667f9eee6ff1b17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897998",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfb2dc750fd7cba0bb985974",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898012",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d99d9-9c8e-74f0-855b-6f681c05c88f.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with city views, stainless steel appliances, and a large island.",
        "public_id": "019d99d9-9c8e-74f0-855b-6f681c05c88f",
        "storage_key": "property/4835820926140416/019d99d9-9c8e-74f0-855b-6f681c05c88f.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aaf189c3649618fd38c76763",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897986",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c25a1366e012adc36d6e98ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898013",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b031f1ca6d0b92c88f13ba29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898014",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94e92c030f1d3cd99b8251ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898016",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6d3cdc1a1e398278e34389e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898022",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d99d9-9d17-720f-8399-e4c1f9d65aa0.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating overlooking the water and city skyline",
        "public_id": "019d99d9-9d17-720f-8399-e4c1f9d65aa0",
        "storage_key": "property/4835820926140416/019d99d9-9d17-720f-8399-e4c1f9d65aa0.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44ba17e26cc511c724ddb28b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898023",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b92e3691ff4cdc13ae1aba4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898024",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fd5fb1384d59846ae4b383e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898025",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d99d9-9c73-7714-b47f-30ad21a7d88a.webp",
      "amenity_image_media": {
        "alt_text": "Stacked white washer and dryer in a closet with shelves.",
        "public_id": "019d99d9-9c73-7714-b47f-30ad21a7d88a",
        "storage_key": "property/4835820926140416/019d99d9-9c73-7714-b47f-30ad21a7d88a.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b03ff6b105dc3442f431dfba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898029",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13781c4a3cd6657078ff34df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898033",
      "title": "Hardwood Vinyl Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d99d9-9ee1-7069-b8ca-6dd97ce8a9c3.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with large windows overlooking a city and bay.",
        "public_id": "019d99d9-9ee1-7069-b8ca-6dd97ce8a9c3",
        "storage_key": "property/4835820926140416/019d99d9-9ee1-7069-b8ca-6dd97ce8a9c3.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6eaaf0c727b6a5402e0ce2bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897971",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f39bf535b0f162c77673b73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898015",
      "title": "Energy Star Certified Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0198-f93f-7518-97c8-5a34a9cc86d6.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, and white countertops.",
        "public_id": "019d0198-f93f-7518-97c8-5a34a9cc86d6",
        "storage_key": "property/4835820926140416/019d0198-f93f-7518-97c8-5a34a9cc86d6.webp",
        "width": 1600,
        "height": 1200
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a8fc4d5e6e4c42762b33b89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897972",
      "title": "Guest Apartment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25bba49794d3b371f3593b93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898017",
      "title": "Instant Hot Water Dispenser",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b662f34fc4ad597cfc9bcff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898018",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_140da8c64111a4d5aa37a8b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898019",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d52209e67b46ade995a3735",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898020",
      "title": "Central AC and Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7de89e10403b8170e5f851e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897978",
      "title": "LEED Rating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04ab2164f6f68fb4bca36f28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897979",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69ea524b06da483c89a410f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898027",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5625cc5ed84f33aa92616c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897982",
      "title": "Movie Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0198-ee12-7439-88a4-5fe8c5d8bd0e.webp",
      "amenity_image_media": {
        "alt_text": "Cozy seating area with large screen TV and small kitchenette in apartment community common room.",
        "public_id": "019d0198-ee12-7439-88a4-5fe8c5d8bd0e",
        "storage_key": "property/4835820926140416/019d0198-ee12-7439-88a4-5fe8c5d8bd0e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1a397769960addfd016aa40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898028",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_797b04b05e8c5699517442d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897985",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7182675ef6b70103bddd140",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898031",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21c3b9c42441ab6e54558e24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898032",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39932ced0b69e8d4cbfbe6f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897987",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af4edf276751d9db277e0c14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897988",
      "title": "Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-bede-75b9-989a-7af6413e9fcc.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with pool table, foosball table, kitchen area, and seating.",
        "public_id": "01a03c73-bede-75b9-989a-7af6413e9fcc",
        "storage_key": "property/4835820926140416/01a03c73-bede-75b9-989a-7af6413e9fcc.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6d46fcb0eac01ce9b43527c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898034",
      "title": "Hidden TV Outlets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07333cfabe534a000bf09ede",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898035",
      "title": "Fingerprint Safe",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e85fa796d749435618b5d70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897989",
      "title": "On-Site ATM",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cdef639d0ae412039b08612",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898036",
      "title": "Deep Soaking Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db6c9f014e9190783f3d3aa0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897990",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-bee8-7738-9eca-3b7870836fa2.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with pool table, foosball table, and kitchen area.",
        "public_id": "01a03c73-bee8-7738-9eca-3b7870836fa2",
        "storage_key": "property/4835820926140416/01a03c73-bee8-7738-9eca-3b7870836fa2.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Tower 12 Resident Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fa5199e8d18771343976519",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897991",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cda9adeb15aa2ce5b6e857f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898037",
      "title": "USB Charging Ports",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d95dceba8686010b8ac45df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898038",
      "title": "Designer Tile Sorround",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c85adfc91c36e6e3a61e65e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768320",
      "title": "accessible",
      "amount": "false",
      "description": "accessible",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc8fcbe2b0c1df6dba35db4d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897994",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51020191c5e0568c082b5f07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898039",
      "title": "Solar Shades",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1048543416c24188ca677da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768322",
      "title": "Balcony",
      "amount": "false",
      "description": "Balcony",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d163db841c43869357065f2e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897995",
      "title": "Rooftop Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-bed9-73b9-a9d8-bf3cb12b81aa.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop terrace with city skyline view, seating, and fire pit.",
        "public_id": "01a03c73-bed9-73b9-a9d8-bf3cb12b81aa",
        "storage_key": "property/4835820926140416/01a03c73-bed9-73b9-a9d8-bf3cb12b81aa.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4eedf8728aa4351ec6244ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898040",
      "title": "California Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e38ff3cb090979a16dd10645",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897996",
      "title": "Waterfront",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55423d9eeb9419b5437d3a40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768323",
      "title": "Corner Unit",
      "amount": "false",
      "description": "Corner Unit",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f437b45d76da818615c6167",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898041",
      "title": "Wine Fridge*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ad9de2de5d7da0a463dc8ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768324",
      "title": "Double Balcony",
      "amount": "false",
      "description": "Double Balcony",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7908b633a933cb992c122db2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897999",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15261cb6ce4756e68766256a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898000",
      "title": "Fitness Programs/Classes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25ea843879ee5a1905c09256",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898042",
      "title": "Soft Close Drawers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baeb9fef70d8747431f366bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768326",
      "title": "Floor Level 10",
      "amount": "false",
      "description": "Floor Level 10",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e3a169d88034e2d5828ba0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898001",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf4e42eb6296fca4b4e4b7fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768328",
      "title": "Floor Level 11",
      "amount": "false",
      "description": "Floor Level 11",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0db44b133d8fa4ca42d59d15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898002",
      "title": "Yoga Studio/Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_274c427213b5eec67dcc85e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768329",
      "title": "Floor Level 12",
      "amount": "false",
      "description": "Floor Level 12",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df5252344e1445312a431a19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898003",
      "title": "Wifi in Amenity Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5c6c97be9ffa85327b1a908",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768330",
      "title": "Floor Level 13",
      "amount": "false",
      "description": "Floor Level 13",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edc293a568e93469f14d7fa8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898004",
      "title": "Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb1678fcecbb374a688cceb8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768331",
      "title": "Floor Level 14",
      "amount": "false",
      "description": "Floor Level 14",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3da07ae379f1a4592f75a8b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898005",
      "title": "On-Site Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_502154ac6de61fd8561057fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768359",
      "title": "Floor Level 15",
      "amount": "false",
      "description": "Floor Level 15",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0164633e8412beebaef1788",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898006",
      "title": "Bike Repair/Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b0ee4328211a23eb4da7ace",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768360",
      "title": "Floor Level 16",
      "amount": "false",
      "description": "Floor Level 16",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_892670759a69421565978af3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898007",
      "title": "LEED Silver",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33d646cf5cbc6d5c8413c1b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768361",
      "title": "Floor Level 17",
      "amount": "false",
      "description": "Floor Level 17",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17d749b6d2ac37c1e3fe0ae4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898008",
      "title": "Compost",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_952a2a235cac7971cba4f6b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768363",
      "title": "Floor Level 18",
      "amount": "false",
      "description": "Floor Level 18",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c248a3185c325a825b6eb745",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "124800131",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b342fe94bffa712b10e89de6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898009",
      "title": "Trash Chute w/ Recycling and Compost",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b37fae6b9694b7a84739d7ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768364",
      "title": "Floor Level 19",
      "amount": "false",
      "description": "Floor Level 19",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf30875f10dad93a80ea8a1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86897984",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0b604f8c345e2eff3dad0a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768366",
      "title": "Floor Level 20",
      "amount": "false",
      "description": "Floor Level 20",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c828d83e38fe1b6b5fc2631",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898010",
      "title": "Beverage & Popcorn Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd629f1efa5ca242a4acc2cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768368",
      "title": "Floor Level 21",
      "amount": "false",
      "description": "Floor Level 21",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6b1354e5643da86b2608410",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "86898011",
      "title": "Bluetooth & Chromecast",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dee3088ce231e8fbd9d52090",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768369",
      "title": "Floor Level 22",
      "amount": "false",
      "description": "Floor Level 22",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83ad20fbd903ac6e8b9450d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768370",
      "title": "Floor Level 23",
      "amount": "false",
      "description": "Floor Level 23",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88710a1495ed155a74518c77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768371",
      "title": "Floor Level 24",
      "amount": "false",
      "description": "Floor Level 24",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1542600f965cd3bcfbefd1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768372",
      "title": "Floor Level 25",
      "amount": "false",
      "description": "Floor Level 25",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3f730016aa088bdfb251a24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768374",
      "title": "Floor Level 26",
      "amount": "false",
      "description": "Floor Level 26",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e984947befa88b1fc073b6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768375",
      "title": "Floor Level 27",
      "amount": "false",
      "description": "Floor Level 27",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5cfd87a34536ce5b5645720",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768376",
      "title": "Floor Level 28",
      "amount": "false",
      "description": "Floor Level 28",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cfcefc5212fa1821eca180a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768377",
      "title": "Floor Level 29",
      "amount": "false",
      "description": "Floor Level 29",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37403f70139638173b400875",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768378",
      "title": "Floor Level 3",
      "amount": "false",
      "description": "Floor Level 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_421e9beb151668bf7f0fe54a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768379",
      "title": "Floor Level 30",
      "amount": "false",
      "description": "Floor Level 30",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e30d5e3e9a153e6875dd3a18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768380",
      "title": "Floor Level 31",
      "amount": "false",
      "description": "Floor Level 31",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6338538fa4010e4aac2ec35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768381",
      "title": "Floor Level 32",
      "amount": "false",
      "description": "Floor Level 32",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee7ad3a47ec3869b11d18898",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768382",
      "title": "Floor Level 33",
      "amount": "false",
      "description": "Floor Level 33",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19686317e93c4058978dc3a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768383",
      "title": "Floor Level 4",
      "amount": "false",
      "description": "Floor Level 4",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f32f54c7954e31c75785ac9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768385",
      "title": "Floor Level 5",
      "amount": "false",
      "description": "Floor Level 5",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_651d58e462143c6e9a889cb1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768386",
      "title": "Floor Level 6",
      "amount": "false",
      "description": "Floor Level 6",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_304c67c5ff7d02ef6c324cf2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768388",
      "title": "Floor Level 7",
      "amount": "false",
      "description": "Floor Level 7",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4115e44ae585386e0cd2386f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768389",
      "title": "Floor Level 8",
      "amount": "false",
      "description": "Floor Level 8",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4045677eb54ca16795ef299",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768391",
      "title": "Floor Level 9",
      "amount": "false",
      "description": "Floor Level 9",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb5ed4c14dc8d013f83e2f21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768392",
      "title": "Large Balcony",
      "amount": "false",
      "description": "Large Balcony",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8120347f7aee849c5dd8b0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768394",
      "title": "Large Deck",
      "amount": "false",
      "description": "Large Deck",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c755d0737efa64d0dfae6af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768395",
      "title": "Low Light",
      "amount": "false",
      "description": "Low Light",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4865a8ab188ab3fe7e66411b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768397",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "Vaulted Ceiling",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45f564c1d54ec5741a860ca6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768398",
      "title": "View 1",
      "amount": "false",
      "description": "View 1",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41155fddc0ae9a27bb176fdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768400",
      "title": "View 2",
      "amount": "false",
      "description": "View 2",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_347c15de1a1f00708f0fbb2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768402",
      "title": "View 3",
      "amount": "false",
      "description": "View 3",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2944a0c824d7965cdbf0178e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768403",
      "title": "View 4",
      "amount": "false",
      "description": "View 4",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bddceb1871538e8fb59fae4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768431",
      "title": "View 5",
      "amount": "false",
      "description": "View 5",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5aed7814cbfd9977cee169e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768432",
      "title": "View 6",
      "amount": "false",
      "description": "View 6",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c955aa470216d34de0681ccb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768434",
      "title": "View 7",
      "amount": "false",
      "description": "View 7",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f65ced23cf25c6fbc1128ac9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768435",
      "title": "View 8",
      "amount": "false",
      "description": "View 8",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_532cef600c3db90d21986d70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "126768437",
      "title": "View 9",
      "amount": "false",
      "description": "View 9",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50e8ff0576db472f3df66c49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826609",
      "title": "Northwest Olympic Mountains View",
      "amount": "false",
      "description": "Northwest Olympic Mountains View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81b1b45c38ca7b5f81f6529b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826623",
      "title": "South City View",
      "amount": "false",
      "description": "South City View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fadb4a9bc0524e7581243188",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826772",
      "title": "Glimpse Water/Mount Rainer View",
      "amount": "false",
      "description": "Glimpse Water/Mount Rainer View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9985777bed7b8935762019f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826777",
      "title": "Partial Water & Mount Rainer View",
      "amount": "false",
      "description": "Partial Water & Mount Rainer View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec88b409a685d6a67b763d21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826778",
      "title": "Full Water & Mount Rainer View",
      "amount": "false",
      "description": "Full Water & Mount Rainer View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f8d01d52b11592fedc55531",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826780",
      "title": "Southeast City Panoramic View",
      "amount": "false",
      "description": "Southeast City Panoramic View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bad316c8cd838b50c6d8b778",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826786",
      "title": "Glimpse Water/Space Needle View",
      "amount": "false",
      "description": "Glimpse Water/Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16dad781d49df72a9adfbe64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826787",
      "title": "Partial Water & Space Needle View",
      "amount": "false",
      "description": "Partial Water & Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15e889641f2b5467787af5e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826788",
      "title": "Full Water View",
      "amount": "false",
      "description": "Full Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80814d12a071724ed71aed40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826789",
      "title": "Space Needle View",
      "amount": "false",
      "description": "Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a3306ff22a5636abd41c10e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826790",
      "title": "Water, Rainier & Cascades View",
      "amount": "false",
      "description": "Water, Rainier & Cascades View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfdb0cd056a6cc85c88073ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826791",
      "title": "East City View",
      "amount": "false",
      "description": "East City View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e2e371d6f99d123ac8a3c49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826792",
      "title": "Glimpse Space Needle View",
      "amount": "false",
      "description": "Glimpse Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acbf24278214160f32cc77af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826793",
      "title": "East City W/ Space Needle View",
      "amount": "false",
      "description": "East City W/ Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8f001a725fe63e98b561c7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826794",
      "title": "Space Needle & Cascades View",
      "amount": "false",
      "description": "Space Needle & Cascades View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cf145fcd35acd8fa817b835",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826795",
      "title": "North City View",
      "amount": "false",
      "description": "North City View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0f179d6e342e888258e8098",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826796",
      "title": "Glimpse Water View",
      "amount": "false",
      "description": "Glimpse Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c03f2e3327a9f0831956b1dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826833",
      "title": "Partial Water View",
      "amount": "false",
      "description": "Partial Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad3581b2efcd97154bf0ffc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826838",
      "title": "North City Panoramic View",
      "amount": "false",
      "description": "North City Panoramic View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e067a4572a76ab5aeb0f726e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826844",
      "title": "Northwest Building View",
      "amount": "false",
      "description": "Northwest Building View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9db0ac7d55c2a198635a7119",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826846",
      "title": "Partial Water View",
      "amount": "false",
      "description": "Partial Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd73e0a2d21a8f2b89a6c8a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826850",
      "title": "Water View",
      "amount": "false",
      "description": "Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b05d060ca39b3882489cec59",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826853",
      "title": "Glimpse Space Needle View",
      "amount": "false",
      "description": "Glimpse Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68894fac5cb07d19180e9451",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826859",
      "title": "Partial Space Needle View",
      "amount": "false",
      "description": "Partial Space Needle View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8b08d8f081071e6bb24762b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826866",
      "title": "Northwest Panoramic City View",
      "amount": "false",
      "description": "Northwest Panoramic City View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81abe1600c7b9c601cfddde9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826867",
      "title": "Northwest Water View",
      "amount": "false",
      "description": "Northwest Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6ca1930fb131e3b674f9166",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826868",
      "title": "Partial Balcony View Mount Rainier",
      "amount": "false",
      "description": "Partial Balcony View Mount Rainier",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99b1665d08bc223f7a7bc0f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826869",
      "title": "Balcony View Mount Rainier",
      "amount": "false",
      "description": "Balcony View Mount Rainier",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57ab129c6c30c68b333298ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826871",
      "title": "Mount Rainier & Olympic Mountains View",
      "amount": "false",
      "description": "Mount Rainier & Olympic Mountains View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b82b05beefef3783f71a8b79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826872",
      "title": "Northwest Panoramic Full Water View",
      "amount": "false",
      "description": "Northwest Panoramic Full Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6ff0cca24c3602eebbdf4b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826873",
      "title": "West Building View",
      "amount": "false",
      "description": "West Building View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14b166ec140c64b7a920caf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826874",
      "title": "Glimpse Northwest Water View",
      "amount": "false",
      "description": "Glimpse Northwest Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf27e978c97dd08e58fd87e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826875",
      "title": "Northwest Water & Southwest Mount Rainier View",
      "amount": "false",
      "description": "Northwest Water & Southwest Mount Rainier View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a137d0686cf58a038ba0beac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826876",
      "title": "West Building w/ Waterfront View",
      "amount": "false",
      "description": "West Building w/ Waterfront View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6d149baaa8f3447d5ea9ad2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826878",
      "title": "West Panoramic Full Water View",
      "amount": "false",
      "description": "West Panoramic Full Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a783f2e4b0a3dab4df232a63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826879",
      "title": "Southwest City View",
      "amount": "false",
      "description": "Southwest City View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f23a8da76f3331668baa1bfd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826880",
      "title": "Southwest City w/ Glimpse Water View",
      "amount": "false",
      "description": "Southwest City w/ Glimpse Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3964bf418c28f86b40e4aa1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826881",
      "title": "Southwest City W/ Partial Water View",
      "amount": "false",
      "description": "Southwest City W/ Partial Water View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab9a017d57c04d63031d493d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826882",
      "title": "Water & Glimpse Mount Rainier View",
      "amount": "false",
      "description": "Water & Glimpse Mount Rainier View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fc6805fddf4393c15b5c350",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826883",
      "title": "Water & Partial Mount Rainier View",
      "amount": "false",
      "description": "Water & Partial Mount Rainier View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ded59bb9a0375d9febad7903",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826885",
      "title": "Water & Mount Rainier View",
      "amount": "false",
      "description": "Water & Mount Rainier View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c28051326896a756647863bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "127826886",
      "title": "Southwest Panoramic View",
      "amount": "false",
      "description": "Southwest Panoramic View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_0d5af85c19c0ea9f2b81515d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-b290-76de-8e56-d47371541f8b.webp",
      "image_media": {
        "alt_text": "Spacious living room with large windows and a modern kitchen.",
        "public_id": "01a03751-b290-76de-8e56-d47371541f8b",
        "storage_key": "property/4835820926140416/01a03751-b290-76de-8e56-d47371541f8b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open-concept living area featuring a plush sectional sofa, stylish coffee tables, and a gourmet kitchen with bar seating, all with stunning city and water views.",
      "link": "false",
      "alt_text": "A modern living room with a large window overlooking the water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(50).jpg"
    },
    {
      "id": "ec_312517fa0e36b5ec165af008",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-f325-7089-a28b-41c3ae7ab5c8.webp",
      "image_media": {
        "alt_text": "Panoramic view of a city skyline from a high-rise balcony, featuring water and mountains in the distance.",
        "public_id": "01a03751-f325-7089-a28b-41c3ae7ab5c8",
        "storage_key": "property/4835820926140416/01a03751-f325-7089-a28b-41c3ae7ab5c8.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Experience breathtaking city views from your private balcony. Enjoy the vibrant cityscape, waterfront, and distant mountains from this elevated perspective.",
      "link": "false",
      "alt_text": "A cityscape with a mix of modern and older buildings, a cloudy sky, and a body of water in the distance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(43).jpg"
    },
    {
      "id": "ec_547385d96e305781369b7feb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-d266-7113-be54-a651322c922a.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with fireplace, seating and tables",
        "public_id": "01a03c73-d266-7113-be54-a651322c922a",
        "storage_key": "property/4835820926140416/01a03c73-d266-7113-be54-a651322c922a.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax in style in this spacious outdoor lounge, featuring a grand fireplace, comfortable seating, and dining tables.",
      "link": "false",
      "alt_text": "A patio with a fireplace and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(62).jpg"
    },
    {
      "id": "ec_8a1b79861b352878dad939a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03750-e481-7508-974f-147682453ac5.webp",
      "image_media": {
        "alt_text": "Rooftop patio with fire pit, lounge seating, and city skyline views.",
        "public_id": "01a03750-e481-7508-974f-147682453ac5",
        "storage_key": "property/4835820926140416/01a03750-e481-7508-974f-147682453ac5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our rooftop patio, complete with a cozy fire pit and ample seating for relaxation and entertainment.",
      "link": "false",
      "alt_text": "A rooftop patio with chairs and a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(61).jpg"
    },
    {
      "id": "ec_98474cea3ace13db4ff7358c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-d1ea-72e7-936c-c848a26b9f86.webp",
      "image_media": {
        "alt_text": "Rooftop deck with seating overlooking a city skyline and bay",
        "public_id": "01a03c73-d1ea-72e7-936c-c848a26b9f86",
        "storage_key": "property/4835820926140416/01a03c73-d1ea-72e7-936c-c848a26b9f86.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy stunning city and bay views from the rooftop deck, complete with comfortable seating and a fire pit.",
      "link": "false",
      "alt_text": "A view of a city from a high vantage point with a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(60).jpg"
    },
    {
      "id": "ec_82381e7d0dc9fdec0b27cc74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-d196-778f-9f74-decc6a2652f7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and large windows overlooking the water.",
        "public_id": "01a03c73-d196-778f-9f74-decc6a2652f7",
        "storage_key": "property/4835820926140416/01a03c73-d196-778f-9f74-decc6a2652f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio and weight training equipment, offering stunning waterfront views from floor-to-ceiling windows.",
      "link": "false",
      "alt_text": "A gym with a view of the city skyline.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(59).jpg"
    },
    {
      "id": "ec_f6542c4a8f2699a767af9f5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03750-ec2f-752b-ae98-210247dbb062.webp",
      "image_media": {
        "alt_text": "Billiard table and foosball table in a modern community lounge with kitchen area and TV.",
        "public_id": "01a03750-ec2f-752b-ae98-210247dbb062",
        "storage_key": "property/4835820926140416/01a03750-ec2f-752b-ae98-210247dbb062.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of billiards or foosball in our vibrant community lounge, complete with a full kitchen and entertainment area.",
      "link": "false",
      "alt_text": "A billiard table is in the middle of a room with a bar and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(58).jpg"
    },
    {
      "id": "ec_c731e6a7c5aa3b6129eaa7de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-25a2-7739-88eb-cd3533621ca5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, bar stools, and stainless steel appliances.",
        "public_id": "01a03751-25a2-7739-88eb-cd3533621ca5",
        "storage_key": "property/4835820926140416/01a03751-25a2-7739-88eb-cd3533621ca5.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a large island with seating, stainless steel appliances, and ample cabinet space. Perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with a bar area and a dining table set for two.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(57).jpg"
    },
    {
      "id": "ec_4c343d28021e119387ec9435",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-3a55-725c-b885-04938d279f1e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and living room area, featuring city skyline views.",
        "public_id": "01a03751-3a55-725c-b885-04938d279f1e",
        "storage_key": "property/4835820926140416/01a03751-3a55-725c-b885-04938d279f1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open-concept living space with a sleek kitchen island, comfortable seating, and panoramic city views from large windows.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(56).jpg"
    },
    {
      "id": "ec_1d41b4fce86339ca1bc538b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-5a35-753d-a28a-9e45e0bd64c6.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with built-in shelving and drawers.",
        "public_id": "01a03751-5a35-753d-a28a-9e45e0bd64c6",
        "storage_key": "property/4835820926140416/01a03751-5a35-753d-a28a-9e45e0bd64c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy ample storage space in this impressive walk-in closet, featuring custom shelving and convenient drawers for all your organizational needs.",
      "link": "false",
      "alt_text": "A walk-in closet with white shelving and drawers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(55).jpg"
    },
    {
      "id": "ec_7563ab5089aef6aea42ee18c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-7847-73c8-9379-79cd314ce4ed.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and living area with city view.",
        "public_id": "01a03751-7847-73c8-9379-79cd314ce4ed",
        "storage_key": "property/4835820926140416/01a03751-7847-73c8-9379-79cd314ce4ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish open-concept living space featuring a gourmet kitchen, comfortable living area, and breathtaking city skyline views.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and a dining area with a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(54).jpg"
    },
    {
      "id": "ec_b97748ee4fdb9c0146452cee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-8f6c-71ff-bbd8-85407f2fde54.webp",
      "image_media": {
        "alt_text": "Modern open-concept apartment kitchen and living area with large windows and city views.",
        "public_id": "01a03751-8f6c-71ff-bbd8-85407f2fde54",
        "storage_key": "property/4835820926140416/01a03751-8f6c-71ff-bbd8-85407f2fde54.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Experience luxury living in this stunning apartment featuring a gourmet kitchen, spacious living area, and breathtaking city vistas.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(53).jpg"
    },
    {
      "id": "ec_51bb048098cbfa361e3abe7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-8f83-767f-9ab8-74e6db64ec2d.webp",
      "image_media": {
        "alt_text": "Living room with large windows and city view.",
        "public_id": "01a03751-8f83-767f-9ab8-74e6db64ec2d",
        "storage_key": "property/4835820926140416/01a03751-8f83-767f-9ab8-74e6db64ec2d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living room with a large sectional sofa, modern coffee table, and stunning city and water views.",
      "link": "false",
      "alt_text": "A modern living room with a large window overlooking the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(52).jpg"
    },
    {
      "id": "ec_7b9b71777175ab3f897d38cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-981d-701b-9fbb-88e968a8a714.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet with framed art on the wall.",
        "public_id": "01a03751-981d-701b-9fbb-88e968a8a714",
        "storage_key": "property/4835820926140416/01a03751-981d-701b-9fbb-88e968a8a714.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located in a dedicated laundry closet, with extra storage space on the overhead shelf. Features a decorative framed piece of art.",
      "link": "false",
      "alt_text": "Two white front loading washing machines in a small laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(51).jpg"
    },
    {
      "id": "ec_f94468ca3c3932e142a296f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-bcb5-77be-bff1-b6fff070957f.webp",
      "image_media": {
        "alt_text": "Bedroom with large window overlooking city skyline",
        "public_id": "01a03751-bcb5-77be-bff1-b6fff070957f",
        "storage_key": "property/4835820926140416/01a03751-bcb5-77be-bff1-b6fff070957f.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed, modern nightstand, and a large window with breathtaking city views.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(49).jpg"
    },
    {
      "id": "ec_065125795786b927a7dd81f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03c73-d2c3-750f-aac7-1cc2b067694a.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and pendant lights, overlooking a living room and city view.",
        "public_id": "01a03c73-d2c3-750f-aac7-1cc2b067694a",
        "storage_key": "property/4835820926140416/01a03c73-d2c3-750f-aac7-1cc2b067694a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury living in this spacious apartment, featuring a sleek modern kitchen with a granite island, perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and a view of the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(48).jpg"
    },
    {
      "id": "ec_31875e003f3a1f4fd22b28ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-c9ae-71ce-b106-9be468691785.webp",
      "image_media": {
        "alt_text": "Empty apartment living area with large windows and city view.",
        "public_id": "01a03751-c9ae-71ce-b106-9be468691785",
        "storage_key": "property/4835820926140416/01a03751-c9ae-71ce-b106-9be468691785.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with abundant natural light and stunning city views from large windows. Perfect for modern urban living.",
      "link": "false",
      "alt_text": "A room with a large window and a door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(47).jpg"
    },
    {
      "id": "ec_0eeb4a4c7caa9d0016288488",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-d80d-737f-88da-a8ca160cd8fd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, soaking tub, and glass-enclosed shower.",
        "public_id": "01a03751-d80d-737f-88da-a8ca160cd8fd",
        "storage_key": "property/4835820926140416/01a03751-d80d-737f-88da-a8ca160cd8fd.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Indulge in luxury in this spacious bathroom, featuring a dual vanity and a deep soaking tub perfect for unwinding.",
      "link": "false",
      "alt_text": "A bathroom with a white tub and a white sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(46).jpg"
    },
    {
      "id": "ec_3d0f841330e9ed4e5cae5b02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-e926-72e0-8a9e-aa7cf7968151.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with sink and faucet, large windows with city view.",
        "public_id": "01a03751-e926-72e0-8a9e-aa7cf7968151",
        "storage_key": "property/4835820926140416/01a03751-e926-72e0-8a9e-aa7cf7968151.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with a sink and faucet, perfect for cooking and entertaining. Enjoy breathtaking city views through expansive windows.",
      "link": "false",
      "alt_text": "A kitchen with a large window overlooking a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(45).jpg"
    },
    {
      "id": "ec_a0a55e12f96333a31262099f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-ec19-7698-a346-597f9a8db7e9.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, large island, and city view.",
        "public_id": "01a03751-ec19-7698-a346-597f9a8db7e9",
        "storage_key": "property/4835820926140416/01a03751-ec19-7698-a346-597f9a8db7e9.webp",
        "width": 3034,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Discover this sleek, modern kitchen featuring stainless steel appliances, ample counter space, and breathtaking city views from expansive windows.",
      "link": "false",
      "alt_text": "A modern kitchen with wooden floors and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(44).jpg"
    },
    {
      "id": "ec_57b98bda720f6657a336bcf8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0198-71fc-77fb-8b9a-66346766b2b7.webp",
      "image_media": {
        "alt_text": "Living room with large windows overlooking the city and water, featuring a leather sofa and armchair.",
        "public_id": "019d0198-71fc-77fb-8b9a-66346766b2b7",
        "storage_key": "property/4835820926140416/019d0198-71fc-77fb-8b9a-66346766b2b7.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Expansive living space with panoramic city and water views. Unwind in style with a plush leather sofa and a comfortable armchair.",
      "link": "false",
      "alt_text": "A living room with a view of the cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(42).jpg"
    },
    {
      "id": "ec_b5ff85cd9df6c4417a765a00",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0198-6465-7249-9904-ea63f3b23e71.webp",
      "image_media": {
        "alt_text": "ORA Power Rankings Elite 1% J Turner Research 2024 award badge.",
        "public_id": "019d0198-6465-7249-9904-ea63f3b23e71",
        "storage_key": "property/4835820926140416/019d0198-6465-7249-9904-ea63f3b23e71.webp",
        "width": 2000,
        "height": 1429
      },
      "title": "Other",
      "description": "Awarded the ORA Power Rankings Elite 1% by J Turner Research in 2024, signifying top-tier performance in the multifamily industry.",
      "link": "false",
      "alt_text": "A circular logo with the text \"POWER RANKINGS ELITE 1% Ora 2024 J TURNER RESEARCH\".",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Untitled%20design%20(38).png"
    },
    {
      "id": "ec_cf770f52adb9538a3ac1a01e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03751-fc66-73ab-a7f4-36dc3ecb7007.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with large window overlooking city construction",
        "public_id": "01a03751-fc66-73ab-a7f4-36dc3ecb7007",
        "storage_key": "property/4835820926140416/01a03751-fc66-73ab-a7f4-36dc3ecb7007.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Bright and airy apartment bedroom with a large window offering stunning city views. Perfect for a modern urban lifestyle.",
      "link": "false",
      "alt_text": "A room with a view of a construction site through the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(41).jpg"
    },
    {
      "id": "ec_4a9ccd9c0445f642d1af7089",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019df685-e614-7738-8b9f-4d960c62df50.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a deep soaking tub, separate glass-enclosed shower, and a long vanity with double sinks.",
        "public_id": "019df685-e614-7738-8b9f-4d960c62df50",
        "storage_key": "property/4835820926140416/019df685-e614-7738-8b9f-4d960c62df50.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Experience luxury in this spacious bathroom featuring a deep soaking tub, a walk-in shower, and a double vanity with ample counter space.",
      "link": "false",
      "alt_text": "A modern bathroom with a large tub and a double sink vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Tower_12_Favorites%20(40).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_c60186fcce1ffaaf9b70ebd5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "600 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Relaxed Taiwanese chain featuring hand-pulled noodles, xiaolongbao dumplings and other regional dishes.",
      "poi_long_description": "Diners like this restaurant's delicious and consistently high-quality food, especially the soup dumplings, spicy wontons, and chocolate dumplings with sea salt cream. They also highlight the friendly, attentive, and knowledgeable staff, who provide excellent service. Visitors mention the lively atmosphere and appreciate the convenient online reservation system to avoid long waits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-c6b6-7589-ab27-11157639f6e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-c6b6-7589-ab27-11157639f6e3",
        "storage_key": "property/4835820926140416/01a03efa-c6b6-7589-ab27-11157639f6e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dtf.com/en/locations/seattle-pacific-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=4829861873643955218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "47.6126501",
      "poi_longitude": "-122.335168",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-682-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bffe-73ab-ae02-affbda1ee0ff",
        "storage_key": "property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPemT0bRqkFQREiTAzMgdB0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taiwanese_restaurant"
    },
    {
      "id": "ec_61e5cd0c7c108f16bc5d1b32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1200 E Pike St Suite No. 2, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-b05d-712c-b963-c79b7be05125.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-b05d-712c-b963-c79b7be05125",
        "storage_key": "property/4835820926140416/01a03efa-b05d-712c-b963-c79b7be05125.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/wa/seattle/1200-e.-pike-street-1205?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_term=1205",
      "poi_directions_map_url": "https://maps.google.com/?cid=4892726209442789638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "47.6142778",
      "poi_longitude": "-122.3165507",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-813-2924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bffe-73ab-ae02-affbda1ee0ff",
        "storage_key": "property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJic7fXWVrkFQRBrkUkZB05kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_c500c2f6a881e4b449a10934",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "The Pink Door",
      "poi_type": "Restaurants",
      "poi_address": "1919 Post Alley, Seattle, WA 98101, USA",
      "poi_short_description": "Italian restaurant with cabaret shows and trapeze entertainment, plus terrace with Elliott Bay views.",
      "poi_long_description": "Diners like this restaurant's delicious Italian-American food, with the lasagna, bolognese, and seafood dishes frequently highlighted. They also mention the warm, lively, and unique atmosphere, often enhanced by live music or aerial performances. Guests consistently praise the attentive and friendly staff, noting their excellent service and helpful recommendations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-a18e-7360-b411-e09c1ff1a960.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-a18e-7360-b411-e09c1ff1a960",
        "storage_key": "property/4835820926140416/01a03efa-a18e-7360-b411-e09c1ff1a960.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thepinkdoor.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13451524338311652394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-pink-door",
      "poi_latitude": "47.6103652",
      "poi_longitude": "-122.3425604",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-443-3241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bffe-73ab-ae02-affbda1ee0ff",
        "storage_key": "property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91YOzrJqkFQRKmSW0B1qrbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_6f770b2d629f0cbc446a9a68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Von's 1000Spirits",
      "poi_type": "Restaurants",
      "poi_address": "1225 1st Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Casual dining on burgers, pizza & bar food in a tavern space showcasing a massive booze selection.",
      "poi_long_description": "People say this restaurant offers delicious house-made sourdough pasta and pizza, along with flavorful burgers and a wide selection of unique cocktails. They also highlight the lively atmosphere and the attentive, friendly staff who provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-c638-749d-a1d9-7be9db269299.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-c638-749d-a1d9-7be9db269299",
        "storage_key": "property/4835820926140416/01a03efa-c638-749d-a1d9-7be9db269299.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.vons1000spirits.com/?utm_source=gmb&utm_medium=organic&utm_campaign=gmbpost",
      "poi_directions_map_url": "https://maps.google.com/?cid=5056199159300483347&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vons-1000spirits",
      "poi_latitude": "47.6066052",
      "poi_longitude": "-122.3384085",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-621-8667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bffe-73ab-ae02-affbda1ee0ff",
        "storage_key": "property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSjPILJqkFQRE-m7s1g6K0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_50c35b514e269460527148b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "115 Broadway E, Seattle, WA 98102, USA",
      "poi_short_description": "Long-running fast-food chain with a cult following for its homemade fries, burgers & shakes.",
      "poi_long_description": "Reviewers consistently praise this burger joint for its delicious burgers and thick milkshakes, noting that orders are served fast and hot. Customers also appreciate the affordable prices and the friendly staff.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-b315-756a-a7c9-036903e62fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-b315-756a-a7c9-036903e62fae",
        "storage_key": "property/4835820926140416/01a03efa-b315-756a-a7c9-036903e62fae.webp",
        "width": 1280,
        "height": 912
      },
      "poi_business_url": "http://www.ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17975972120156224243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.6193263",
      "poi_longitude": "-122.3212263",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-323-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bffe-73ab-ae02-affbda1ee0ff",
        "storage_key": "property/4835820926140416/019d0199-bffe-73ab-ae02-affbda1ee0ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cIFkjIVkFQR87o8Cmd7d_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_8d8d403a4dd853e38dd2e3f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "University Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2623 NE University Village St, Seattle, WA 98105, USA",
      "poi_short_description": "Al fresco shopping center since the 1950s, with local stores, well-known brands & dining options.",
      "poi_long_description": "People say this outdoor mall offers a wide variety of high-end stores and restaurants, including a large grocery store. They also highlight the beautiful landscaping, ample outdoor seating, and family-friendly amenities like a play area. Visitors appreciate the convenient parking options and the generally friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-a5e5-744b-83c4-ec71f2183e95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-a5e5-744b-83c4-ec71f2183e95",
        "storage_key": "property/4835820926140416/01a03efa-a5e5-744b-83c4-ec71f2183e95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://uvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185780485491805676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-village",
      "poi_latitude": "47.6618813",
      "poi_longitude": "-122.2990421",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-523-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c03b-748d-acd0-1cf9fbe07726.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c03b-748d-acd0-1cf9fbe07726",
        "storage_key": "property/4835820926140416/019d0199-c03b-748d-acd0-1cf9fbe07726.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_IcB4YUkFQR7E2AoSzhFjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_acc11e015879207cc68ab774",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic items, and delicious prepared foods, including a popular hot bar and bakery. They also highlight the clean, well-organized environment, friendly staff, and convenient parking with validation.\n\nSome reviews mention the prepared food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-a6b2-718f-894f-570c6fb0789a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-a6b2-718f-894f-570c6fb0789a",
        "storage_key": "property/4835820926140416/01a03efa-a6b2-718f-894f-570c6fb0789a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001768",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfff-71e2-b9eb-72d58002f42e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfff-71e2-b9eb-72d58002f42e",
        "storage_key": "property/4835820926140416/019d0199-bfff-71e2-b9eb-72d58002f42e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_227ce1055e19ba73b76ca0b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Uwajimaya Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 5th Ave S, Seattle, WA 98104, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers an extensive selection of fresh produce, seafood, meats, and unique imported ingredients, along with a wide variety of prepared foods and a vibrant food court. Visitors also highlight the clean, well-organized environment and the helpful, friendly staff. They appreciate the convenient parking, which is free for two hours with a $20 purchase and validation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-a1e3-7195-a35d-fbceded4e20c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-a1e3-7195-a35d-fbceded4e20c",
        "storage_key": "property/4835820926140416/01a03efa-a1e3-7195-a35d-fbceded4e20c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/seattle/?utm_source=localprofiles&utm_medium=organic&utm_content=seattle&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=18369564176154316475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-seattle",
      "poi_latitude": "47.5968404",
      "poi_longitude": "-122.3267453",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-624-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfff-71e2-b9eb-72d58002f42e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfff-71e2-b9eb-72d58002f42e",
        "storage_key": "property/4835820926140416/019d0199-bfff-71e2-b9eb-72d58002f42e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9nX27xqkFQRu05rxkrN7f4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "ec_8cdf0d027fc9983be0e00785",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 E Madison St, Seattle, WA 98122, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a great selection of unique and seasonal products, including fresh produce, meats, and baked goods. They also highlight the reasonable prices and the clean, well-stocked shelves. Visitors consistently praise the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-b007-7322-adbb-08d5803b95c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-b007-7322-adbb-08d5803b95c9",
        "storage_key": "property/4835820926140416/01a03efa-b007-7322-adbb-08d5803b95c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/130/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748370317872008118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.61582569999999",
      "poi_longitude": "-122.309937",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-322-7268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfff-71e2-b9eb-72d58002f42e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfff-71e2-b9eb-72d58002f42e",
        "storage_key": "property/4835820926140416/019d0199-bfff-71e2-b9eb-72d58002f42e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0M1ztNqkFQRtgspEllQxk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8719af13f32347b04c7db451",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-a0e5-767a-8a88-4ddd4be3d28a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-a0e5-767a-8a88-4ddd4be3d28a",
        "storage_key": "property/4835820926140416/01a03efa-a0e5-767a-8a88-4ddd4be3d28a.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.6565919",
      "poi_longitude": "-122.3126783",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfeb-73ed-ad38-5afafc226b90",
        "storage_key": "property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_30e5762d999cbf4fb0b543cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Seattle Public Library - Central Library",
      "poi_type": "Education",
      "poi_address": "1000 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "Dramatic, view-filled facility lending books, films & music, plus numerous public computers.",
      "poi_long_description": "People say this library features stunning, modern architecture with many floors to explore, offering a vast collection of books and resources, including music practice rooms and a children's section. Visitors also highlight the numerous comfortable seating areas with power outlets, free Wi-Fi, and a cafe. They also appreciate the friendly, helpful staff and the convenient parking options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-fd49-7009-9b27-9bda91ebb5b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-fd49-7009-9b27-9bda91ebb5b1",
        "storage_key": "property/4835820926140416/01a03efa-fd49-7009-9b27-9bda91ebb5b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spl.org/hours-and-locations/central-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=12943420815159197138&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-public-library---central-library",
      "poi_latitude": "47.6067659",
      "poi_longitude": "-122.3326439",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-386-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-513d-723c-afa1-179d9d3dacb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03efb-513d-723c-afa1-179d9d3dacb6",
        "storage_key": "property/4835820926140416/01a03efb-513d-723c-afa1-179d9d3dacb6.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ55fLWVtBkFQR0v31eadEoLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_0bb37578d6a4699b1ac67226",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Seattle Central College",
      "poi_type": "Education",
      "poi_address": "1701 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-cc1d-7707-b81f-7ca27c84a06b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-cc1d-7707-b81f-7ca27c84a06b",
        "storage_key": "property/4835820926140416/01a03efa-cc1d-7707-b81f-7ca27c84a06b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://seattlecentral.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860090414231206236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-central-college",
      "poi_latitude": "47.6167229",
      "poi_longitude": "-122.3215965",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-934-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfeb-73ed-ad38-5afafc226b90",
        "storage_key": "property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScFRw8xqkFQRXDnUjTNcGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_6f7a677f7ad6f4afcbc1447c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Seattle University",
      "poi_type": "Education",
      "poi_address": "901 12th Ave, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-cedf-71d9-82f6-d521cdbf6573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-cedf-71d9-82f6-d521cdbf6573",
        "storage_key": "property/4835820926140416/01a03efa-cedf-71d9-82f6-d521cdbf6573.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.seattleu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887710188514951233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-university",
      "poi_latitude": "47.6083842",
      "poi_longitude": "-122.3175073",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfeb-73ed-ad38-5afafc226b90",
        "storage_key": "property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZv0y8hqkFQRQcB9L4Wi1EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ca3e167e60f3f44d62195cdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "North Seattle College",
      "poi_type": "Education",
      "poi_address": "9600 College Way N, Seattle, WA 98103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-d1a1-770a-888f-a16d89410969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-d1a1-770a-888f-a16d89410969",
        "storage_key": "property/4835820926140416/01a03efa-d1a1-770a-888f-a16d89410969.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://northseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=404283079753513623&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-seattle-college",
      "poi_latitude": "47.6989479",
      "poi_longitude": "-122.3326717",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-934-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfeb-73ed-ad38-5afafc226b90",
        "storage_key": "property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWVdQEUkFQRl7porVFNnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_87c381bdecfc056229133616",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "T-Mobile Park",
      "poi_type": "Entertainment",
      "poi_address": "1250 1st Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Seattle Mariners' ballpark with city skyline views, lots of stadium eats & a retractable roof.",
      "poi_long_description": "People say this stadium offers exciting baseball games, concerts, and fireworks shows, with a retractable roof and views of the city skyline. They highlight the electric atmosphere, family-friendly vibe, and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-d000-75a5-b4a6-105fa41354f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-d000-75a5-b4a6-105fa41354f9",
        "storage_key": "property/4835820926140416/01a03efa-d000-75a5-b4a6-105fa41354f9.webp",
        "width": 1242,
        "height": 540
      },
      "poi_business_url": "http://seattle.mariners.mlb.com/sea/ballpark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14337255265305820565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t-mobile-park",
      "poi_latitude": "47.591472",
      "poi_longitude": "-122.3325832",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-346-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c36e-7434-a273-9a50bc0c9971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c36e-7434-a273-9a50bc0c9971",
        "storage_key": "property/4835820926140416/019d0199-c36e-7434-a273-9a50bc0c9971.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28RdUJ9qkFQRlf2mprMp-MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_441e286d900b8faaa9144b4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "People say this arena is a beautiful, modern, and clean facility with comfortable seating and great views from almost anywhere. They also highlight the excellent sound quality and electric atmosphere for both concerts and sporting events. Visitors appreciate the friendly and helpful staff, as well as the wide variety of food options and convenient public transportation access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-2975-73e0-81c5-2f7ec4a20729.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-2975-73e0-81c5-2f7ec4a20729",
        "storage_key": "property/4835820926140416/01a03efb-2975-73e0-81c5-2f7ec4a20729.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.622094",
      "poi_longitude": "-122.353984",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_8cb12366428607248701bfe6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Lumen Field",
      "poi_type": "Entertainment",
      "poi_address": "800 Occidental Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Home of the Seahawks & Sounders, this 68,740-seat multipurpose stadium features skyline views.",
      "poi_long_description": "People say this stadium offers a wide variety of food and drink options, including local favorites, and has clean, well-maintained restrooms. They highlight the energetic atmosphere, the helpful staff, and the clear views of the field from most seats. Visitors also appreciate the easy access by public transportation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-d6e8-7128-ba90-0efd4eb887f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-d6e8-7128-ba90-0efd4eb887f3",
        "storage_key": "property/4835820926140416/01a03efa-d6e8-7128-ba90-0efd4eb887f3.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://www.lumenfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11976986007816512220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lumen-field",
      "poi_latitude": "47.5951518",
      "poi_longitude": "-122.3316394",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-381-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c36e-7434-a273-9a50bc0c9971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c36e-7434-a273-9a50bc0c9971",
        "storage_key": "property/4835820926140416/019d0199-c36e-7434-a273-9a50bc0c9971.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKxjxuaNqkFQR3CK6O1HNNqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_831b9e90a8f49a3db2c99c11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Woodland Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98103, USA",
      "poi_short_description": "92-acre zoo with nearly 300 species, a vintage carousel, summer concerts & an indoor play space.",
      "poi_long_description": "People say this zoo features a wide variety of animals in natural, spacious habitats and offers stunning holiday light displays. Visitors also highlight the friendly, knowledgeable staff and the clean, well-maintained grounds and restrooms. They also like the family-friendly atmosphere, with plenty of shaded areas and activities for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-e5e9-7390-9fb9-8209113b7058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-e5e9-7390-9fb9-8209113b7058",
        "storage_key": "property/4835820926140416/01a03efa-e5e9-7390-9fb9-8209113b7058.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962776519554476210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-park-zoo",
      "poi_latitude": "47.668436",
      "poi_longitude": "-122.3508786",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-548-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydSuSkkUkFQRsqhB-cEtYnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_36bd6167e34365955c0e816d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Seattle Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1483 Alaskan Way Pier 59, Seattle, WA 98101, USA",
      "poi_short_description": "Popular waterfront aquarium with interactive exhibits, a cafe & virtual reality shows.",
      "poi_long_description": "People say this aquarium has stunning exhibits, including a new Ocean Pavilion with a massive tank, and interactive touch pools with starfish and sea urchins. Visitors also highlight the friendly and knowledgeable staff, and appreciate the family-friendly atmosphere.\n\nSome reviews mention the prices can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-ef61-7131-97a8-b34235db9467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-ef61-7131-97a8-b34235db9467",
        "storage_key": "property/4835820926140416/01a03efa-ef61-7131-97a8-b34235db9467.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7753481524406941315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-aquarium",
      "poi_latitude": "47.6074002",
      "poi_longitude": "-122.3429559",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-386-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-5127-7318-9b7f-6e424ff427a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03efb-5127-7318-9b7f-6e424ff427a7",
        "storage_key": "property/4835820926140416/01a03efb-5127-7318-9b7f-6e424ff427a7.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJQ_oEiK1qkFQRg3bU4l3mmWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_6386d2dedcf1414336fec9c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1416 NW Ballard Way, Seattle, WA 98107, USA",
      "poi_short_description": "false",
      "poi_long_description": "Reviewers consistently praise this gym for its great variety of new and clean equipment, including numerous squat racks and a pool, and note the friendly staff.\n\nOther reviews mention the gym can be overcrowded and staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-9b6e-75d9-8bdc-55b3b7d44020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0199-9b6e-75d9-8bdc-55b3b7d44020",
        "storage_key": "property/4835820926140416/019d0199-9b6e-75d9-8bdc-55b3b7d44020.webp",
        "width": 1170,
        "height": 905
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=455&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3768693322368076231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.6624093",
      "poi_longitude": "-122.3754951",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-508-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfJWZLcVkFQRx8ki-5sWTTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_d2ae9049138fc83447c64a7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Olympic Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 Leary Ave NW, Seattle, WA 98107, USA",
      "poi_short_description": "Elegant sports club with weights, cardio machines, group classes, an indoor pool, saunas & jacuzzis.",
      "poi_long_description": "Elegant sports club with weights, cardio machines, group classes, an indoor pool, saunas & jacuzzis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-f96e-739b-a46b-209017073c91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-f96e-739b-a46b-209017073c91",
        "storage_key": "property/4835820926140416/01a03efa-f96e-739b-a46b-209017073c91.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.olympicathleticclub.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243484350012506487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-athletic-club",
      "poi_latitude": "47.6664152",
      "poi_longitude": "-122.3828324",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-944-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-6exLYVkFQRd8Fg0Qp0R4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f5bb4dc357efd29fdfdb760c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Equinox Rainier Square",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Union St Suite 220, Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "Reviewers consistently describe this gym as beautiful, clean, and well-maintained, offering a wide variety of classes and featuring friendly, helpful staff.\n\nOther reviews mention the equipment can be limited and the gym can be overcrowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-e14f-7727-ab04-15088942a68a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-e14f-7727-ab04-15088942a68a",
        "storage_key": "property/4835820926140416/01a03efa-e14f-7727-ab04-15088942a68a.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.equinox.com/clubs/washington/rainiersquare?cid=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3460855741733625954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "equinox-rainier-square",
      "poi_latitude": "47.6092692",
      "poi_longitude": "-122.335354",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-336-0260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5aexv1rkFQRYmDn8PVtBzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_80fbc4928a76f2ba5d0790ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 NW Market St #100, Seattle, WA 98107, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this gym is clean and well-maintained with a good selection of machines and equipment, and staff are friendly and helpful.\n\nOther reviews mention the gym can be overly warm and the hours can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-fc92-7715-b91e-8636d1c46e04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-fc92-7715-b91e-8636d1c46e04",
        "storage_key": "property/4835820926140416/01a03efa-fc92-7715-b91e-8636d1c46e04.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/seattle-ballard-wa?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18000937299387102910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.668813",
      "poi_longitude": "-122.3773675",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-260-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1WjAVG8VkFQRvjYMyhkt0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_aa73ca123069c8eea302dbb9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Barry's Seattle",
      "poi_type": "Health and Wellness",
      "poi_address": "112 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Chains for group training in the Red Room on treadmills, interspersed with bench exercises.",
      "poi_long_description": "People say this gym offers challenging and fun high-intensity interval training workouts in a clean, well-maintained facility. They also highlight the energetic atmosphere, motivating music, and effective lighting. Guests mention the welcoming and helpful staff and instructors who provide clear guidance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-f6b0-72d9-91fd-56b663921108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-f6b0-72d9-91fd-56b663921108",
        "storage_key": "property/4835820926140416/01a03efa-f6b0-72d9-91fd-56b663921108.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.barrys.com/studio/seattle",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874324567168923080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barrys-seattle",
      "poi_latitude": "47.6188612",
      "poi_longitude": "-122.3382048",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-687-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8epeK8VkFQRyDXkY0PwAho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_8f7d6a33ed59fce79ddd4ccf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "West Seattle Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2629 SW Andover St, Seattle, WA 98126, USA",
      "poi_short_description": "Swimming, spacious gym featuring a rock-climbing wall and a heated pool.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including a large pool, sauna, steam room, and hot tub, with many classes included in membership. They also highlight the clean facilities, helpful staff, and inclusive atmosphere.\n\nSome reviews mention the equipment can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-f337-73de-b41d-c688d0529616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-f337-73de-b41d-c688d0529616",
        "storage_key": "property/4835820926140416/01a03efa-f337-73de-b41d-c688d0529616.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://westseattlehc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17611443290596558280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-seattle-health-club",
      "poi_latitude": "47.5680479",
      "poi_longitude": "-122.3676256",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-556-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizEFLE7YB0ERyMXxBV1qaPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_9c9091186c4042ea5af741c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "[solidcore] SLU",
      "poi_type": "Health and Wellness",
      "poi_address": "2139 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this gym offers challenging workouts that combine strength, resistance training, Pilates, and cardio, with a focus on full-body engagement. They also highlight the amazing instructors and the convenient app for booking classes.\n\nSome reviews mention the app can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-fef0-70c2-b613-4b3b23e4c9aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efa-fef0-70c2-b613-4b3b23e4c9aa",
        "storage_key": "property/4835820926140416/01a03efa-fef0-70c2-b613-4b3b23e4c9aa.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://solidcore.co/studios/slu?siteId=5723430&locationId=1&utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12001859543961006521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidcore-slu",
      "poi_latitude": "47.6153071",
      "poi_longitude": "-122.3404108",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-594-3782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-bfeb-73ed-ad38-5afafc226b90",
        "storage_key": "property/4835820926140416/019d0199-bfeb-73ed-ad38-5afafc226b90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Vi9xnMVkFQRuXHtqaorj6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_8f594abcdbcb87afa5d11156",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Emerald City Athletics - Wallingford",
      "poi_type": "Health and Wellness",
      "poi_address": "3924 Stone Way N, Seattle, WA 98103, USA",
      "poi_short_description": "Fitness center offering training and group classes in a spacious space.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including free weights and machines, and provides a clean, well-maintained facility. They also highlight the knowledgeable and attentive staff, especially the personal trainers who offer excellent guidance, personalized workout plans, and nutrition advice. Guests mention the affordable membership options and convenient free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-2f06-70f9-8407-1e6e473bcdd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-2f06-70f9-8407-1e6e473bcdd0",
        "storage_key": "property/4835820926140416/01a03efb-2f06-70f9-8407-1e6e473bcdd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://emeraldcitygyms.com/wallingford",
      "poi_directions_map_url": "https://maps.google.com/?cid=17401796993204784779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emerald-city-athletics---wallingford",
      "poi_latitude": "47.6550022",
      "poi_longitude": "-122.3421001",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-557-4909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXjXiv8UkFQRi45uqSqaf_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_fa2ec069c53db47939c1966e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-0601-7271-bf3e-720789de034e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-0601-7271-bf3e-720789de034e",
        "storage_key": "property/4835820926140416/01a03efb-0601-7271-bf3e-720789de034e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3a7-704b-9445-4afd114c2b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3a7-704b-9445-4afd114c2b18",
        "storage_key": "property/4835820926140416/019d0199-c3a7-704b-9445-4afd114c2b18.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1764b9edd97c291fc83b6c89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-096b-7632-b974-db0e23541fed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-096b-7632-b974-db0e23541fed",
        "storage_key": "property/4835820926140416/01a03efb-096b-7632-b974-db0e23541fed.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3a7-704b-9445-4afd114c2b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3a7-704b-9445-4afd114c2b18",
        "storage_key": "property/4835820926140416/019d0199-c3a7-704b-9445-4afd114c2b18.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0f39e39416ad3b36546f49dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_long_description": "Visitors say this park offers stunning panoramic views of the Seattle skyline, Lake Union, and the Space Needle, with unique industrial structures adding character. They also highlight the ample green spaces, making it ideal for picnics, relaxing, and watching boats and seaplanes. Guests mention the convenient parking and a playground, making it a great spot for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-245f-72ca-9ec1-a598a402e186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-245f-72ca-9ec1-a598a402e186",
        "storage_key": "property/4835820926140416/01a03efb-245f-72ca-9ec1-a598a402e186.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3ec-745e-ae75-05a6a8652ae1",
        "storage_key": "property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_02769bb88d3bdaa8164f4f87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Kerry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "211 W Highland Dr, Seattle, WA 98119, USA",
      "poi_short_description": "Panoramic views of Downtown & the Space Needle draw visitors to this small neighborhood park.",
      "poi_long_description": "Visitors say this park offers iconic, breathtaking views of the Seattle skyline, including the Space Needle and Mount Rainier on clear days, making it perfect for photos. They also highlight the peaceful atmosphere, especially at sunset or night, and appreciate the free street parking, though it can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-1f4b-735b-8c41-1d940f47337b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-1f4b-735b-8c41-1d940f47337b",
        "storage_key": "property/4835820926140416/01a03efb-1f4b-735b-8c41-1d940f47337b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.seattle.gov/parks/find/parks/kerry-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3744576093846549902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kerry-park",
      "poi_latitude": "47.6294692",
      "poi_longitude": "-122.3599224",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3ec-745e-ae75-05a6a8652ae1",
        "storage_key": "property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS2ELmoVkFQRjrUkJB5o9zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6808ecfc1c0a99a914353758",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Seattle, WA 98199, USA",
      "poi_short_description": "Seattle's largest green space features miles of rugged trails & beaches, plus views of the Sound.",
      "poi_long_description": "People say this park offers a wide variety of well-maintained trails, including forest paths, open meadows, and beach access with stunning views of Puget Sound and the Olympic Mountains. Visitors also highlight the ample parking options and clean restrooms. They also appreciate the peaceful atmosphere, making it a great escape within the city.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-ad4d-75da-9228-9baea1f92fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0199-ad4d-75da-9228-9baea1f92fb6",
        "storage_key": "property/4835820926140416/019d0199-ad4d-75da-9228-9baea1f92fb6.webp",
        "width": 735,
        "height": 490
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/discovery-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5879522751650882336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "47.6613197",
      "poi_longitude": "-122.4171413",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3ec-745e-ae75-05a6a8652ae1",
        "storage_key": "property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0CO4fAVkFQRIGP6pMpCmFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fcd71ff428cbe49f9708de69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Golden Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8498 Seaview Pl NW, Seattle, WA 98117, USA",
      "poi_short_description": "City park draws outdoor lovers for Puget Sound & mountain views, trails & a dog off-leash area.",
      "poi_long_description": "Visitors say this park offers beautiful sandy beaches, stunning views of Puget Sound and the Olympic Mountains, and opportunities to see seals and sea lions. They also highlight the various recreational activities available, including volleyball, swimming, hiking trails, and designated fire pits. Guests mention it's a great spot for picnics, family outings, and watching unforgettable sunsets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-1e8a-72f3-885e-a736e05dc3da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-1e8a-72f3-885e-a736e05dc3da",
        "storage_key": "property/4835820926140416/01a03efb-1e8a-72f3-885e-a736e05dc3da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/golden-gardens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569770599323732682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-gardens-park",
      "poi_latitude": "47.6917517",
      "poi_longitude": "-122.4030912",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3ec-745e-ae75-05a6a8652ae1",
        "storage_key": "property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72JgjmQWkFQRygp_TI2DLFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_7be15edee827288de768b4a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Seward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 Lake Washington Blvd S, Seattle, WA 98118, USA",
      "poi_short_description": "Wooded refuge boasting a 300-acre forest with hiking trails, walking paths, beaches & a playground.",
      "poi_long_description": "People say this park offers beautiful views of Mount Rainier and Lake Washington, along with extensive walking, running, and biking trails, including a paved loop and wooded paths. Visitors also highlight the clean restrooms, picnic areas, and playgrounds, making it suitable for families. They appreciate the ample parking, though it can get busy, especially on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-3021-76b6-bd24-b8e4aa69a421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-3021-76b6-bd24-b8e4aa69a421",
        "storage_key": "property/4835820926140416/01a03efb-3021-76b6-bd24-b8e4aa69a421.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/seward-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4357544938507271096&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seward-park",
      "poi_latitude": "47.5496046",
      "poi_longitude": "-122.2573574",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 206-684-4396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c3ec-745e-ae75-05a6a8652ae1",
        "storage_key": "property/4835820926140416/019d0199-c3ec-745e-ae75-05a6a8652ae1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fB3DCFqkFQRuPuGyAgceTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b7591f865aa2ef4fdbd98b61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "U District",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-23f5-74e6-ae56-8d1bc9baec6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-23f5-74e6-ae56-8d1bc9baec6c",
        "storage_key": "property/4835820926140416/01a03efb-23f5-74e6-ae56-8d1bc9baec6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/u-district-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8874690119994055692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "u-district",
      "poi_latitude": "47.6599885",
      "poi_longitude": "-122.3140745",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03efb-5145-768d-9c1b-4c23d5e6501c",
        "storage_key": "property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n1LIsUkFQRDBzq3aQ7KXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_00be5475eb98edac199161d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Westlake",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-17f0-7170-83f8-f4f2d0bb685b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-17f0-7170-83f8-f4f2d0bb685b",
        "storage_key": "property/4835820926140416/01a03efb-17f0-7170-83f8-f4f2d0bb685b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5693109731314450214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westlake",
      "poi_latitude": "47.61157",
      "poi_longitude": "-122.33672",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03efb-5145-768d-9c1b-4c23d5e6501c",
        "storage_key": "property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQyrwLRqkFQRJj9RIiP9AU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_9b9729812148c9661fc80de7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "University of Washington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-3335-74c9-9702-709d23de88dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-3335-74c9-9702-709d23de88dd",
        "storage_key": "property/4835820926140416/01a03efb-3335-74c9-9702-709d23de88dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/university-washington-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042961121833481987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-station",
      "poi_latitude": "47.65031",
      "poi_longitude": "-122.30374",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03efb-5145-768d-9c1b-4c23d5e6501c",
        "storage_key": "property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdBrZusUkFQRA3cRa4t5Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_679195286595a583bb3254c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Symphony",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-2911-74db-a596-e1d66c2ef959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-2911-74db-a596-e1d66c2ef959",
        "storage_key": "property/4835820926140416/01a03efb-2911-74db-a596-e1d66c2ef959.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10052292521089458792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "symphony",
      "poi_latitude": "47.60781",
      "poi_longitude": "-122.33602",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03efb-5145-768d-9c1b-4c23d5e6501c",
        "storage_key": "property/4835820926140416/01a03efb-5145-768d-9c1b-4c23d5e6501c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRf6wbNqkFQRaGLa4cnqgIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_ba40f9d81e91c8b4df643236",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "King County International Airport - Boeing Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7277 Perimeter Rd S, Seattle, WA 98108, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this airport offers easy access to the tarmac and clean facilities, with plenty of parking next to the terminal. They also highlight the fast, efficient service and the friendly, professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-41bb-75fb-ba10-074dd9ac7ae4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-41bb-75fb-ba10-074dd9ac7ae4",
        "storage_key": "property/4835820926140416/01a03efb-41bb-75fb-ba10-074dd9ac7ae4.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "https://www.kingcounty.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635828346216693482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-county-international-airport---boeing-field",
      "poi_latitude": "47.5369043",
      "poi_longitude": "-122.3038555",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-296-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c67e-74cd-829f-33889c89afbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c67e-74cd-829f-33889c89afbf",
        "storage_key": "property/4835820926140416/019d0199-c67e-74cd-829f-33889c89afbf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_--ofVBkFQR6r7ut1HFVUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_83ba948accb02192a0117500",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Amazon - Doppler",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2021 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-3e96-7519-be75-ff85bfa7ebc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-3e96-7519-be75-ff85bfa7ebc3",
        "storage_key": "property/4835820926140416/01a03efb-3e96-7519-be75-ff85bfa7ebc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11285464150585336235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon---doppler",
      "poi_latitude": "47.6150245",
      "poi_longitude": "-122.338417",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-280-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubQpU0oVkFQRq2ELHdoFnpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_394717e45d19ab2bd4db6ceb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Amazon re:Invent",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2121 8th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-4213-74af-ab49-2da8caf8cd1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-4213-74af-ab49-2da8caf8cd1a",
        "storage_key": "property/4835820926140416/01a03efb-4213-74af-ab49-2da8caf8cd1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16622250602859019695&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-reinvent",
      "poi_latitude": "47.6167313",
      "poi_longitude": "-122.3386481",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfQ75DIVkFQRrz3v1toYruY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_62d93311bcb12a40d82e8bef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "The Spheres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2111 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_long_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-48b0-739b-b430-ec4cff1b825b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-48b0-739b-b430-ec4cff1b825b",
        "storage_key": "property/4835820926140416/01a03efb-48b0-739b-b430-ec4cff1b825b.webp",
        "width": 1093,
        "height": 1280
      },
      "poi_business_url": "https://www.seattlespheres.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167585885114143500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-spheres",
      "poi_latitude": "47.615728",
      "poi_longitude": "-122.3395104",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsX8RyksVkFQRDBMdYsrOOX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_b3adc5397d0c1c95d96755aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Amazon Nitro North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2250 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-4996-70ff-ab10-81c04d712436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-4996-70ff-ab10-81c04d712436",
        "storage_key": "property/4835820926140416/01a03efb-4996-70ff-ab10-81c04d712436.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=577859250656015239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-nitro-north",
      "poi_latitude": "47.6174162",
      "poi_longitude": "-122.3408815",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-946-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBay75mUVkFQRh3OGRe33BAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_e767e081a2db11288bbe2506",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "google_places",
      "poi_name": "Expedia Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 Expedia Group Wy W, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-43fd-7113-a2d9-9cdfd52bd9d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03efb-43fd-7113-a2d9-9cdfd52bd9d8",
        "storage_key": "property/4835820926140416/01a03efb-43fd-7113-a2d9-9cdfd52bd9d8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://careers.expediagroup.com/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15469363506382453691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "expedia-group",
      "poi_latitude": "47.6289934",
      "poi_longitude": "-122.3752914",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-679-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0199-c379-700f-9451-e2f44fd2bd31",
        "storage_key": "property/4835820926140416/019d0199-c379-700f-9451-e2f44fd2bd31.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaBVEIhskFQRuztRGyY4rtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_789b3fa25f72eb0fa8df050e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3613fab3c7e48efb93d46344",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_166415a5030b4db1d9991f42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2b1ef35a0eafb0518fe77c3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_40fbc9ffed1a5eb03346c61e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b24067ee42575d33e5c2af15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_550e27cb5f7f403325832fcf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "rating": "5",
      "name": "Diana Nguyen",
      "text": "(This is a repost because my prior review didn't show up)\n\nThis wonderful place was recommended by Christina N. -  an leasing agent who gave us a great tour.\n\nI was fortunate enough to stay for a short period of time and my experience was very accommodating! The concierge and staff are immensely welcoming. As I visited the different floors, the residents were all really nice.\n\nTheir 34th floor though? It has a amazing (and long) veranda and fireplaces to see the gorgeous view.\n\nThe communal shared space was very large with multiple areas.\n\nThe gym? Its got a large number of machines and yoga and dance room.\n\nThe apartment views are exceptional, the fixtures are already provided (and dependable), and the color scheme of the rooms are very aesthetically pleasing.\n\nAll the rooms are extremely clean and well-maintained.\n\nI was in awe, really, of the large windows, good lighting (and good energy) , and the spaciousness and intuitively good designs of these apartments. I would definitely stay here via recommendation from Christina.",
      "date": "2026-08-03",
      "title": "false"
    },
    {
      "id": "ec_65e20bd61ee6cae616bb6623",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "rating": "5",
      "name": "Karl Kunkel",
      "text": "We unequivocally recommend Tower 12 apartments for those seeking comfortable, secure high-rise living in Seattle. Having recently completed our first six months in the Tower 12 community, we want to share that our experience has been exceptional, as our expectations have consistently been met or exceeded by all members of the staff here.\n\nFrom our visiting and leasing experiences to the maintenance team that responds quickly and works efficiently, the entire staff is friendly, well-trained, highly respectful and always responsive. The concierge crew deserves special recognition, as they keep residents’ operations running smoothly with pickups, deliveries, communications, regular community events, etc. …\n\nThe building and its facilities are also top-notch. Our apartment fixtures are superior to most apartment furnishings, and the same can be said for the equipment in the fitness center and other commons areas.\n\nAnd finally, there are the views and sunsets! Whether from the rooftop terrace, the fitness center or other commons’ areas, the views are among the best anywhere. It’s hard to imagine any better option for downtown living.",
      "date": "2025-12-09",
      "title": "false"
    },
    {
      "id": "ec_b476351c765d3bc3498183bb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "rating": "5",
      "name": "Noa Lalena",
      "text": "After living at Tower12 for the past two years, we spent some time deciding whether to move or renew for another year.\nOne of the main reasons we chose to stay was the improvement we’ve seen in the building, especially since Aizah became the manager.\n\nShe has made a real difference in the overall resident experience. Communication feels better, issues are handled with more care, and the building feels like it’s moving in a positive direction.\n\nWe’re happy we decided to renew, and Aizah was definitely a big part of that decision. I would gladly recommend Tower12 to anyone looking for a place to call home!",
      "date": "2026-06-13",
      "title": "false"
    },
    {
      "id": "ec_e95e643eb2f604b0ce75f22d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "rating": "5",
      "name": "Jay Johnson",
      "text": "Gorgeous building, with friendly staff, and truly stellar sunset views.  The rooftop makes for a perfect summer grill-and-chill spot, or a workout with a view!\nBy the way, did I mention the views? They’re pretty rad!\nThis is a well built building, you’re not going to hear your neighbors through the walls. A/C is a blessing on those hot summer days.\n\nThe only downside? The elevators can be a bit of a wait during “rush hour,” though that just gives a few moments to catch up with your neighbors, and meet everyone’s pups 🤠\n\nPS: Having a deli/bodega in the building makes living so convenient!",
      "date": "2025-07-15",
      "title": "false"
    },
    {
      "id": "ec_403a24cd142dc8319fad988b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "rating": "5",
      "name": "Maria Rosas",
      "text": "I attended two events, graduation and send off, at the Tower 12 yesterday, 6/14/26. I had a great time since the place was so comfortable. It was so nice view that I ended up doing my TikTok video. Coming in the building was easy and the consierge attendant was gracious and friendly. Thank you so much. God bless!",
      "date": "2026-06-15",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_76afb053-d096-4b7d-8641-606d029e6706",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d019a-9566-727b-b412-bef225a5fc4d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment building lobby with contemporary decor, seating areas, and glass double doors.",
        "public_id": "019d019a-9566-727b-b412-bef225a5fc4d",
        "storage_key": "property/4835820926140416/019d019a-9566-727b-b412-bef225a5fc4d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lobby and Sky Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=k8MGMPZqnFv"
    },
    {
      "id": "custom_85a1093a-8569-45c0-9230-93d80a8cb556",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-671c-77eb-99b5-33c1440666b1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-671c-77eb-99b5-33c1440666b1",
        "storage_key": "property/4835820926140416/019ddcc7-671c-77eb-99b5-33c1440666b1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A Floorplan | 1x1 + Den | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=29M7Ajpdrtg"
    },
    {
      "id": "custom_47247944-bef9-482d-8ea2-166c2fe7c89b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d019a-9855-73b1-9728-d336a3be88d2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty living room with large window and city view",
        "public_id": "019d019a-9855-73b1-9728-d336a3be88d2",
        "storage_key": "property/4835820926140416/019d019a-9855-73b1-9728-d336a3be88d2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A Floor Plan | 1x1 + Den | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RKoMKCXzjzr"
    },
    {
      "id": "custom_ab15d518-1434-4bc4-9fd2-2f3579aa1e14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-6d51-75b9-887c-9db85e482f2e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-6d51-75b9-887c-9db85e482f2e",
        "storage_key": "property/4835820926140416/019ddcc7-6d51-75b9-887c-9db85e482f2e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B Floorplan | 2x2 | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=e1PY1gux9N6"
    },
    {
      "id": "custom_03d723ff-0245-4261-87cc-d5b43569eee5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-de6c-771c-8143-2f691f1f3376.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efa-de6c-771c-8143-2f691f1f3376",
        "storage_key": "property/4835820926140416/01a03efa-de6c-771c-8143-2f691f1f3376.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B Floorplan | 2x2 | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DfhUJzB3Son"
    },
    {
      "id": "custom_01b28285-b1fc-42df-8517-4323583866d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-6715-760d-b169-c5a1ade9bca4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-6715-760d-b169-c5a1ade9bca4",
        "storage_key": "property/4835820926140416/019ddcc7-6715-760d-b169-c5a1ade9bca4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "C Floorplan | 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Lqs6tv5F6JE"
    },
    {
      "id": "custom_a4adf3d7-f226-4f9a-b75d-747f1155398a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-f5f4-72ef-a86d-4ddc7bfd2e72.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efa-f5f4-72ef-a86d-4ddc7bfd2e72",
        "storage_key": "property/4835820926140416/01a03efa-f5f4-72ef-a86d-4ddc7bfd2e72.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "D Floorplan | Studio | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Ne2Qhy8MBL7"
    },
    {
      "id": "custom_6739a35f-6baa-4df0-a835-e6851f06aab6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efa-f59a-75dc-8b38-f68d0d06168b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efa-f59a-75dc-8b38-f68d0d06168b",
        "storage_key": "property/4835820926140416/01a03efa-f59a-75dc-8b38-f68d0d06168b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "D Floorplan | Studio | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pAr2tzSTo7T"
    },
    {
      "id": "custom_f574235e-7da4-4dc5-bdbc-7f07ce948b97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d019a-8cb4-746f-992b-c50dd85db078.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a brown tufted sofa, coffee table, desk, and guitar.",
        "public_id": "019d019a-8cb4-746f-992b-c50dd85db078",
        "storage_key": "property/4835820926140416/019d019a-8cb4-746f-992b-c50dd85db078.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "E Floorplan | 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ELBjT9K1eHh"
    },
    {
      "id": "custom_7e7222bb-030e-499f-8d12-040d093a5f9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-096c-747b-8de6-43c24abb88c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-096c-747b-8de6-43c24abb88c9",
        "storage_key": "property/4835820926140416/01a03efb-096c-747b-8de6-43c24abb88c9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "F Floorplan | 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2KCV7pD8S3N"
    },
    {
      "id": "custom_3c76b359-6c9f-4f67-aa2e-22e210aae64e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-0bc0-774c-86ba-814608db787a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-0bc0-774c-86ba-814608db787a",
        "storage_key": "property/4835820926140416/01a03efb-0bc0-774c-86ba-814608db787a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "GU3 Floorplan | 1x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wDNpWpTXa3E"
    },
    {
      "id": "custom_d411ddf5-570b-41cd-bc37-b95f4ac896a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-0bd4-706e-b2ca-a87f1f3d0a0a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-0bd4-706e-b2ca-a87f1f3d0a0a",
        "storage_key": "property/4835820926140416/01a03efb-0bd4-706e-b2ca-a87f1f3d0a0a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "GU4 Floorplan | Studio | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6M2LoSNuRdz"
    },
    {
      "id": "custom_0cbf101f-3598-416a-9ba2-8690556c273c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-2309-703c-a34f-38b2b4928167.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-2309-703c-a34f-38b2b4928167",
        "storage_key": "property/4835820926140416/01a03efb-2309-703c-a34f-38b2b4928167.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "GU1 Floorplan | Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=URMMbY7rEfG"
    },
    {
      "id": "custom_ba654e50-bfb8-4824-8576-b2f0a068aa7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-23fe-76b5-b111-0374f40613e9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-23fe-76b5-b111-0374f40613e9",
        "storage_key": "property/4835820926140416/01a03efb-23fe-76b5-b111-0374f40613e9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "H Floorplan | 1x1 + Den | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PVoZkYFjzvk"
    },
    {
      "id": "custom_a36f1c68-e686-4637-ba01-a084acbc402d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-66f0-72f8-8ff5-aeae584b92c6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-66f0-72f8-8ff5-aeae584b92c6",
        "storage_key": "property/4835820926140416/019ddcc7-66f0-72f8-8ff5-aeae584b92c6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "H Floorplan | 1x1 + Den | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8MjTxuX3WC7"
    },
    {
      "id": "custom_999d794c-efa4-407a-9963-fcd41dcd1729",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-6d1f-75bc-96a9-c6ba0fd5eba2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-6d1f-75bc-96a9-c6ba0fd5eba2",
        "storage_key": "property/4835820926140416/019ddcc7-6d1f-75bc-96a9-c6ba0fd5eba2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "I Floorplan | 1x1 + Den | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Av8honX8Hje"
    },
    {
      "id": "custom_b1b237ce-4120-4da3-9e9b-d3532738a2f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-3c5d-77df-815b-415e2807aeaa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-3c5d-77df-815b-415e2807aeaa",
        "storage_key": "property/4835820926140416/01a03efb-3c5d-77df-815b-415e2807aeaa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "I Floorplan | 1x1 + Den | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FKajiysqvya"
    },
    {
      "id": "custom_200a8210-57d8-456f-a068-921c7f9af646",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-6d21-7456-bfe2-a6ff58f4cf78.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-6d21-7456-bfe2-a6ff58f4cf78",
        "storage_key": "property/4835820926140416/019ddcc7-6d21-7456-bfe2-a6ff58f4cf78.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "K Floorplan | 2x2 | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QJmoKGe36sk"
    },
    {
      "id": "custom_c1b0b258-2692-455b-b4c1-fe50be436208",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-49da-75be-a88a-f94115aaf6b5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-49da-75be-a88a-f94115aaf6b5",
        "storage_key": "property/4835820926140416/01a03efb-49da-75be-a88a-f94115aaf6b5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "K Floorplan | 2x2 | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4yWsP3cqajW"
    },
    {
      "id": "custom_9d1190f4-cdd3-4bd6-9c17-f7a7e1e966c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-4ab6-773e-bcd8-793e7c254366.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-4ab6-773e-bcd8-793e7c254366",
        "storage_key": "property/4835820926140416/01a03efb-4ab6-773e-bcd8-793e7c254366.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "L Floor Plan | 1x1 + Den",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jF3YEhn5m9b"
    },
    {
      "id": "custom_fa85bd05-463c-4d12-9939-e83a0ae09fed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-4be7-761e-8538-efda808da043.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-4be7-761e-8538-efda808da043",
        "storage_key": "property/4835820926140416/01a03efb-4be7-761e-8538-efda808da043.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "M Floorplan | 2x2 + Den | Sand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NvnSq6zAgmd"
    },
    {
      "id": "custom_f5811b79-a54c-43e1-bd9a-5c7edb5ba32c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-6d68-745d-b3cb-f1328da1a4e1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-6d68-745d-b3cb-f1328da1a4e1",
        "storage_key": "property/4835820926140416/019ddcc7-6d68-745d-b3cb-f1328da1a4e1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "M Floorplan | 2x2 + Den | Driftwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LvHhw9ywpBd"
    },
    {
      "id": "custom_37b04e48-721e-41da-873f-550bb7ed7080",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-537b-7734-a582-609732cef1e9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-537b-7734-a582-609732cef1e9",
        "storage_key": "property/4835820926140416/01a03efb-537b-7734-a582-609732cef1e9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "M Floor Plan | 2x2 + Den | ADA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=evPtoQ3vFtY"
    },
    {
      "id": "custom_abdced89-cc67-479e-9887-f7d7a6f3fabb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d019a-8ca9-7058-81d5-0341abe3e22b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment kitchen and living area with panoramic city and ocean views.",
        "public_id": "019d019a-8ca9-7058-81d5-0341abe3e22b",
        "storage_key": "property/4835820926140416/019d019a-8ca9-7058-81d5-0341abe3e22b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 1 | 2x2.5 | Mist",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4TDVmH6ZDJ3"
    },
    {
      "id": "custom_75b4d784-3dd8-4954-b5c3-cfad37de512f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-749f-7658-90e2-610907d95dc1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-749f-7658-90e2-610907d95dc1",
        "storage_key": "property/4835820926140416/019ddcc7-749f-7658-90e2-610907d95dc1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 1 | 2x2.5 | Timber",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UV7zHZQkuYR"
    },
    {
      "id": "custom_fb617216-31e9-407e-a981-048434de651e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-7382-766e-9498-ba5cd643dce9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-7382-766e-9498-ba5cd643dce9",
        "storage_key": "property/4835820926140416/019ddcc7-7382-766e-9498-ba5cd643dce9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 2 | 2x2.5 | Mist",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=njVi2N5WSNg"
    },
    {
      "id": "custom_c38812fd-097d-4c35-8721-b70ad9b982d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d019a-8bee-74c9-b3c6-63a2c3e0cdec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and large windows with a city view.",
        "public_id": "019d019a-8bee-74c9-b3c6-63a2c3e0cdec",
        "storage_key": "property/4835820926140416/019d019a-8bee-74c9-b3c6-63a2c3e0cdec.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 2 | 2x2.5 | Timber",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ijoTz5SPUJE"
    },
    {
      "id": "custom_41f8cbb6-8601-4441-b8cd-90e42bc97168",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-7397-73ed-be0b-51b9b6202cc3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-7397-73ed-be0b-51b9b6202cc3",
        "storage_key": "property/4835820926140416/019ddcc7-7397-73ed-be0b-51b9b6202cc3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 3 | 2x2.5 | Timber",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oFyUf1sJAK1"
    },
    {
      "id": "custom_4ecd4772-5518-49f1-aed0-87f2fb2c7353",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-6ea2-721b-9821-fa72f5ed0f9e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-6ea2-721b-9821-fa72f5ed0f9e",
        "storage_key": "property/4835820926140416/019ddcc7-6ea2-721b-9821-fa72f5ed0f9e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 4 | 1x1.5 | Mist",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FRurB1ZqPQa"
    },
    {
      "id": "custom_b96614dd-4e98-4a62-8543-4e31201ba473",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-5b93-7468-898a-2e49b148e148.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-5b93-7468-898a-2e49b148e148",
        "storage_key": "property/4835820926140416/01a03efb-5b93-7468-898a-2e49b148e148.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 5 | 1x1.5 | Mist",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=peZwxZCuWiy"
    },
    {
      "id": "custom_aaf1d262-cc5f-44c2-98ba-9e0eb646a1a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019ddcc7-7308-7628-aea3-d9bab8a881cf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc7-7308-7628-aea3-d9bab8a881cf",
        "storage_key": "property/4835820926140416/019ddcc7-7308-7628-aea3-d9bab8a881cf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Penthouse 6 | 2x2.5 | Timber",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FyqjA7DvqKF"
    },
    {
      "id": "custom_94bf04c3-ac3e-4889-81af-8c1adb9c4cb3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-6330-748b-bbd1-424a3460ce94.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-6330-748b-bbd1-424a3460ce94",
        "storage_key": "property/4835820926140416/01a03efb-6330-748b-bbd1-424a3460ce94.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1br 1ba - 2002",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CrzijFXNqSK"
    },
    {
      "id": "custom_878f3d8f-b9dc-46e8-85e1-01e0b4187af0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-62df-749f-b10d-7c6368d6378b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-62df-749f-b10d-7c6368d6378b",
        "storage_key": "property/4835820926140416/01a03efb-62df-749f-b10d-7c6368d6378b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Studio - 505",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KVzqx1W6zNA"
    },
    {
      "id": "custom_e740da27-a0a1-4d01-83ff-47284b419ff0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/01a03efb-69d1-767b-b65b-daeaf80cbe55.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03efb-69d1-767b-b65b-daeaf80cbe55",
        "storage_key": "property/4835820926140416/01a03efb-69d1-767b-b65b-daeaf80cbe55.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Studio - 302",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=D2SZfNNz3Jc"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_9d35fa737cb725c606d6fb0c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "e64beea0bd901760",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d5859ef490c894cbd5cc1cfb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "ee67c661f8c68f1a",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8779ae10d25179f3e7abd667",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "775d5b715d7880ac",
      "name": "Early Termination Fee",
      "description": "Early Termination Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4451e2123cdbe37814abbbfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "50f709212c3559f8",
      "name": "Transfer Fee",
      "description": "Fee to transfer apartments",
      "amount": 1000,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_710689d46d0b882f87a0f1a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "efc83f2df1c94439",
      "name": "Water Charge",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_50b3e23ac063aa93b9ea2d03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "93009e3fadebff21",
      "name": "Sewer Charge",
      "description": "Sewer Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9145b5792a20c660ffd76a05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "e4651585af2b72b3",
      "name": "Garbage Charge",
      "description": "Garbage Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_34f789c62e9a7f4d2342b64b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "fd132f56d49bc82b",
      "name": "Pest Control",
      "description": "Pest Control Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "pest",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6b2d6c83791be6b73b72533d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "b02365b8ac7df85f",
      "name": "Gas Charge",
      "description": "Gas Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c03a344c30cc367c44f5c5d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "a4ea24c80a544b9e",
      "name": "Sewer Service",
      "description": "Base Sewer Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewerb",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8c73db88ac7cf97c1e943eab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "7aba17d1c375f702",
      "name": "Common Area Electric",
      "description": "Common Area Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c857a4482b3d7183e80ed670",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "cac461adce307f20",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Admin Fee",
      "amount": 3.95,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_71ad510e0f2130bde69be7b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "2476357",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_bc0a7b7c760af6faa69e8136",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "yardi",
      "external_id": "2466302",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-7820-7234-9417-c5c725f7a7cc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "tower-12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416"
    },
    {
      "lead_collector_id": "0198aa47-7888-7719-a9a7-5e0842df3d72",
      "lead_source": "FACEBOOK_ADS",
      "name": "tower-12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416"
    },
    {
      "lead_collector_id": "0198aa47-78ea-76aa-9b5e-153ab26c313c",
      "lead_source": "LANDING_PAGE",
      "name": "tower-12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-seattle-tower12",
      "search_query": "apartments with in-unit washer dryer Seattle",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Find Seattle apartments with in-unit washer dryer at Tower 12. Experience convenience and comfort in our modern living spaces.",
      "page_copy": "At Tower 12, located in the heart of Seattle, we prioritize convenience and comfort, offering apartments with in-unit washer dryer. Enjoy coming home to a modern space equipped with these essential appliances, enhancing your daily living experience. Our prime location near Pike Place Market not only offers stunning views but also keeps you close to Seattle's vibrant lifestyle.\n\nOur Seattle apartments with in-unit washer dryer are perfect for those seeking practicality and modern amenities. Tower 12 provides additional features like a rooftop lounge and pet park, making it an ideal community for urban dwellers. Explore floor plans ranging from studios to two-bedroom units and discover a home that fits your lifestyle. Schedule a tour today and see the difference!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seattle Apartments with In-Unit Washer Dryer",
      "seo_description": "Discover Tower 12 in Seattle offering apartments with in-unit washer dryer and more. Close to Pike Place Market!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "dog-park-apartments-pike-place-market",
      "search_query": "dog park apartments near Pike Place Market",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Pike Place",
      "h2_subtitle": "Explore dog park apartments near Pike Place Market at Tower 12. We provide pet-friendly living with great amenities in Seattle.",
      "page_copy": "Nestled near the iconic Pike Place Market, Tower 12 offers pet-friendly apartments featuring an exclusive dog park. This is the ideal community for pet owners who want a vibrant urban lifestyle without sacrificing convenience. Our Seattle apartments, complete with a pet park, ensure you and your furry friends can live comfortably and happily.\n\nDiscover the benefits of living close to Pike Place Market in our dog park apartments. Tower 12 not only offers a welcoming environment for pets but also provides incredible amenities like a rooftop lounge and media center. Choose from studio, one, or two-bedroom floor plans designed to meet your needs. Embrace a community that values your lifestyle at Tower 12.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments by Pike Place Market",
      "seo_description": "Find dog-friendly apartments near Pike Place Market at Tower 12. Enjoy a pet park and urban living in Seattle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-downtown-seattle",
      "search_query": "air-conditioned apartments in downtown Seattle",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Downtown",
      "h2_subtitle": "Discover air-conditioned apartments in downtown Seattle at Tower 12. Enjoy comfort and modern amenities in the heart of the city.",
      "page_copy": "Stay comfortable year-round in air-conditioned apartments in downtown Seattle at Tower 12. Our modern living spaces provide the perfect escape from the city’s bustling energy, ensuring you have a cool sanctuary even during the warmest days. Located near Pike Place Market, Tower 12 offers a blend of comfort and convenience like no other.\n\nIn addition to air conditioning, Tower 12 boasts a variety of first-class amenities, including a rooftop lounge and media center. Our studio, one, and two-bedroom floor plans cater to a variety of lifestyle needs, making us the perfect choice for urban dwellers seeking refined living in downtown Seattle. Visit us to explore these exceptional air-conditioned spaces today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Downtown Seattle",
      "seo_description": "Explore air-conditioned apartments in downtown Seattle at Tower 12. Located near Pike Place Market with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "luxury-apartments-rooftop-lounge-seattle",
      "search_query": "luxury apartments with rooftop lounge in Seattle",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Rooftop Lounge",
      "h2_subtitle": "Experience luxury apartments with a rooftop lounge at Tower 12 in Seattle. Enjoy stunning views and premium amenities.",
      "page_copy": "Tower 12 is the pinnacle of luxury living in Seattle, boasting apartments with an exclusive rooftop lounge. Our residents enjoy breathtaking views of the Seattle skyline, making every moment relaxed and picturesque. Situated near Pike Place Market, our luxury apartments provide an unparalleled urban experience.\n\nBeyond the stunning rooftop lounge, Tower 12 offers a suite of exceptional amenities, including a media center and pet park. With a variety of studio, one, and two-bedroom floor plans, our community caters to those who seek opulence and comfort in their living environment. Embrace the vibrant lifestyle of Seattle while residing in premium luxury apartments with top-tier features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Rooftop Lounge Seattle",
      "seo_description": "Discover luxury apartments with a rooftop lounge at Tower 12 in Seattle. Close to Pike Place Market with stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-seattle-98121",
      "search_query": "apartments with fitness center 98121",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center 98121",
      "h2_subtitle": "Find apartments with a fitness center in the 98121 area at Tower 12. Enjoy living in a lively Seattle neighborhood.",
      "page_copy": "Located in the heart of Seattle's vibrant 98121 zip code, Tower 12 offers residents the advantage of a well-equipped fitness center. Perfectly designed for health enthusiasts, our apartments ensure you can maintain your fitness routine without leaving the building. Experience a convenient lifestyle with Tower 12's modern amenities.\n\nIn addition to a fitness center, Tower 12 provides a range of top-tier features including a rooftop lounge, media center, and pet park. Choose from stylish studio, one, or two-bedroom floor plans that cater to urban dwellers looking for comfort and luxury. Situated near iconic Pike Place Market, our apartments offer the ideal setting for a balanced, active lifestyle in Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in 98121",
      "seo_description": "Explore apartments with a fitness center at Tower 12 in Seattle's 98121. Enjoy premium amenities and a lively neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "studio-apartments-seattle-pike-place-market",
      "search_query": "studio apartments Seattle Pike Place Market",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near Pike Place Market",
      "h2_subtitle": "Discover studio apartments in Seattle near Pike Place Market at Tower 12. Experience urban living at its finest.",
      "page_copy": "If you're looking to live near the iconic Pike Place Market, Tower 12 offers exquisite studio apartments in Seattle. Perfectly situated for those seeking a vibrant city lifestyle, our studios provide both comfort and convenience in a prime location. With modern designs and premium finishes, our studio apartments cater to anyone wanting to immerse themselves in the downtown Seattle experience.\n\nTower 12 not only places you close to the heart of Seattle's cultural scene but also provides exceptional amenities like a rooftop lounge and a state-of-the-art fitness center. Whether you’re a busy professional or simply enjoy the buzz of city life, our studio apartments make the perfect home base, offering you easy access to all that Seattle has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Seattle Pike Place Market",
      "seo_description": "Find studio apartments near Pike Place Market at Tower 12. Enjoy modern living with easy access to Seattle’s cultural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-seattle-98121",
      "search_query": "one bedroom apartments in 98121",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in 98121",
      "h2_subtitle": "Explore spacious one-bedroom apartments in Seattle's 98121 zip code at Tower 12. Enjoy urban living with premium amenities.",
      "page_copy": "Tower 12 is your premier destination for elegant one-bedroom apartments in Seattle's bustling 98121 area. Designed with contemporary flair and comfort in mind, these apartments offer the ideal retreat in the heart of the city. Experience the perfect blend of style and functionality, making urban living a dream come true.\n\nOur community boasts a variety of top-notch amenities, including a rooftop lounge and media center. Located near the vibrant Pike Place Market, Tower 12 provides a seamless connection to Seattle's best dining, shopping, and entertainment options. Discover the essence of city living right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Seattle 98121",
      "seo_description": "Discover one-bedroom apartments at Tower 12 in Seattle’s 98121. Enjoy urban living and premium amenities near Pike Place Market.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "4835820926140416",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-pike-place-market",
      "search_query": "two bedroom apartments near Pike Place Market",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Pike Place",
      "h2_subtitle": "Find spacious two-bedroom apartments near Pike Place Market at Tower 12. Enjoy a dynamic Seattle lifestyle with top amenities.",
      "page_copy": "At Tower 12, you'll discover beautifully appointed two-bedroom apartments just steps from the iconic Pike Place Market. Enjoy the perfect blend of convenience and luxury in one of Seattle's most coveted neighborhoods. These residences offer ample space, modern designs, and a perfect setting for both tranquility and urban excitement.\n\nEach apartment is part of a vibrant community that comes complete with outstanding amenities, such as a serene rooftop lounge and a pet-friendly environment. Whether you're entertaining friends or enjoying a quiet evening at home, Tower 12's two-bedroom options provide the ideal setting for your Seattle experience, all minutes from the cultural heartbeat of the city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
      "featured_image_media": {
        "alt_text": "Modern open-concept kitchen and living area with city views.",
        "public_id": "019d0199-1a98-748a-b2d0-0866fb6d1da2",
        "storage_key": "property/4835820926140416/019d0199-1a98-748a-b2d0-0866fb6d1da2.webp",
        "width": 1200,
        "height": 675
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Pike Place",
      "seo_description": "Explore two-bedroom apartments near Pike Place Market at Tower 12. Enjoy luxury living in the heart of Seattle with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "188"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "372526969"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2067095400&rfs&SSCM=y"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PVTBV6H"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "b5bc96f5-61f9-41ef-989b-41adb2d73e39"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Weidner Classic"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/10e43f2c-6175-4f7b-92d3-b95e9524c825/app.js?property=10e43f2c-6175-4f7b-92d3-b95e9524c825&propertyName=Tower+12&channelUuid=c248f031-8dac-11ec-afb4-42010aa8d42b\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5535327834"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://vid.cdn-website.com/c035667c/videos/EsOuYxV8TWUiGg7aFK2W_Tower12-Video1-2-v.mp4"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlZXZ3lRcWdIaW8yV28wREozdlFRZEE9PSIsInZhbHVlIjoiTTQ3VGZKTkRJT2dRWkYyQXd6d212dz09IiwibWFjIjoiYzgxYTY1NWIzYTk0MGZhMjc3MzQ5OTI5ZGY2ZTFhZWJiYmFjZjcxNTc3YTQwYWJkMzViMmIzNDJjNzJmNzJjZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "188",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "372526969",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2067095400&rfs&SSCM=y",
  "custom_google_gtm_id": "GTM-PVTBV6H",
  "custom_rollout_phase": "Phase 7",
  "custom_rentgrata_token": "b5bc96f5-61f9-41ef-989b-41adb2d73e39",
  "custom_vibesites_theme": "Weidner Classic",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/10e43f2c-6175-4f7b-92d3-b95e9524c825/app.js?property=10e43f2c-6175-4f7b-92d3-b95e9524c825&propertyName=Tower+12&channelUuid=c248f031-8dac-11ec-afb4-42010aa8d42b\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "5535327834",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_property_featured_video": "https://vid.cdn-website.com/c035667c/videos/EsOuYxV8TWUiGg7aFK2W_Tower12-Video1-2-v.mp4",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlZXZ3lRcWdIaW8yV28wREozdlFRZEE9PSIsInZhbHVlIjoiTTQ3VGZKTkRJT2dRWkYyQXd6d212dz09IiwibWFjIjoiYzgxYTY1NWIzYTk0MGZhMjc3MzQ5OTI5ZGY2ZTFhZWJiYmFjZjcxNTc3YTQwYWJkMzViMmIzNDJjNzJmNzJjZSJ9"
};

export const generatedAt = '2026-11-03T21:12:01.595Z';
